;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="3939bf35-ffdd-402d-b837-64c34a83fe39",e._sentryDebugIdIdentifier="sentry-dbid-3939bf35-ffdd-402d-b837-64c34a83fe39")}catch(e){}}();
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 63680:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {


// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(7452);
// EXTERNAL MODULE: ./assets/common/js/polyfills.js
var polyfills = __webpack_require__(58345);
// EXTERNAL MODULE: ./node_modules/mobx/dist/mobx.esm.js
var mobx_esm = __webpack_require__(27813);
// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/sdk.js + 1 modules
var sdk = __webpack_require__(87447);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(4899);
// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/index.js + 225 modules
var esm = __webpack_require__(43560);
// EXTERNAL MODULE: ./assets/exception-handling/blacklisted-urls.js
var blacklisted_urls = __webpack_require__(1858);
// EXTERNAL MODULE: ./assets/exception-handling/blacklisted-errors.js
var blacklisted_errors = __webpack_require__(83731);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/react-dom/client.js
var client = __webpack_require__(5338);
// EXTERNAL MODULE: ./node_modules/react-router/dist/index.js
var dist = __webpack_require__(47767);
// EXTERNAL MODULE: ./node_modules/react-router-dom/dist/index.js
var react_router_dom_dist = __webpack_require__(84976);
// EXTERNAL MODULE: ./node_modules/mobx-react/dist/mobxreact.esm.js + 14 modules
var mobxreact_esm = __webpack_require__(44015);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(95093);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/@remix-run/router/dist/router.js
var router = __webpack_require__(45588);
// EXTERNAL MODULE: ./react/helpers/utils.ts
var utils = __webpack_require__(41906);
// EXTERNAL MODULE: ./react/public-api/index.tsx
var public_api = __webpack_require__(35750);
// EXTERNAL MODULE: ./react/stores/hooks.ts
var hooks = __webpack_require__(9432);
;// ./react/client/hooks.tsx





const PublicCompanyContext = /*#__PURE__*/(0,react.createContext)(null);
function PublicCompanyProvider(_ref) {
  var _matchPath;
  let {
    children
  } = _ref;
  // Matches base path of each client route
  const {
    companyId
  } = (_matchPath = (0,router/* matchPath */.B6)({
    path: '/:lang/client/:companyId/',
    end: false
  }, window.location.pathname)) === null || _matchPath === void 0 ? void 0 : _matchPath.params;
  const publicApi = (0,public_api/* default */.Ay)();
  const [company, setCompany] = (0,react.useState)(null);
  const [handleLoadCompany, isLoadingCompany] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    const result = await publicApi.CompanyCompanyApi.retrieve({
      id: companyId
    });
    setCompany(result);
  });
  (0,react.useEffect)(() => {
    handleLoadCompany();
  }, [companyId]);
  const contextValue = (0,react.useMemo)(() => ({
    company,
    handleLoadCompany,
    isLoadingCompany
  }), [company, handleLoadCompany, isLoadingCompany]);
  return /*#__PURE__*/react.createElement(PublicCompanyContext.Provider, {
    value: contextValue
  }, children);
}
const usePublicCompany = () => (0,utils/* useContextSafe */.qr)(PublicCompanyContext);

// EXTERNAL MODULE: ./react/components/RatingEmoji/index.tsx + 3 modules
var RatingEmoji = __webpack_require__(49186);
// EXTERNAL MODULE: ./react/layouts/main-sidebar/LogoIcon.tsx
var LogoIcon = __webpack_require__(56858);
// EXTERNAL MODULE: ./react/ui/index.ts + 3 modules
var ui = __webpack_require__(35443);
;// ./react/badge/BadgeReport.tsx











function BadgeReport() {
  const publicApi = (0,public_api/* default */.Ay)();
  const {
    companyId,
    lang
  } = (0,dist/* useParams */.g)();
  const {
    company
  } = usePublicCompany();
  const [canRetainBadge, setCanRetainBadge] = (0,react.useState)(null);
  const [comments, setComments] = (0,react.useState)(null);
  const [nextPage, setNextPage] = (0,react.useState)(1);
  const load = async () => {
    if (!companyId || !lang || nextPage === null) return;
    const data = await publicApi.BadgeBadgeReportCommentsApi.list({
      company_id: companyId,
      language: lang,
      page: nextPage,
      page_size: 10
    });
    setComments(prev => [...(prev !== null && prev !== void 0 ? prev : []), ...data.results]);
    setNextPage(data.total_pages > nextPage ? nextPage + 1 : null);
  };
  const [handleLoad, isLoading] = (0,hooks/* useAsyncFunction */.m_)(load);
  const intersecionObserver = (0,react.useRef)(null);
  const lastCommentElementRef = (0,react.useCallback)(node => {
    if (isLoading) return;
    if (intersecionObserver.current) intersecionObserver.current.disconnect();
    intersecionObserver.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && nextPage && !isLoading) {
        handleLoad();
      }
    });
    if (node) intersecionObserver.current.observe(node);
  }, [isLoading, nextPage]);
  const loadIfCanRetainBadge = async () => {
    if (!companyId || !lang) return;
    const data = await publicApi.BadgeCanRetainBadgeApi.retrieve({
      company_id: companyId
    });
    setCanRetainBadge(data.can_retain_badge);
  };
  (0,react.useEffect)(() => {
    const loadData = async () => {
      await loadIfCanRetainBadge();
      await handleLoad();
    };
    loadData();
  }, []);
  if (company === null || comments === null && isLoading) {
    return /*#__PURE__*/react.createElement(ui/* Overlay */.hJ, {
      open: true,
      onOverlayClick: () => null
    }, /*#__PURE__*/react.createElement("div", {
      className: "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform"
    }, /*#__PURE__*/react.createElement(ui/* Loader */.aH, {
      size: "huge"
    })));
  }
  return /*#__PURE__*/react.createElement("div", {
    className: "min-h-screen bg-gray-100"
  }, /*#__PURE__*/react.createElement("div", {
    className: "mx-auto max-w-4xl md:p-6"
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-6 text-center"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-4 py-8 shadow sm:px-10 md:rounded-md"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col items-center justify-around md:flex-row"
  }, company.logo_url ? /*#__PURE__*/react.createElement("img", {
    src: (0,utils/* currentLanguage */.aS)(company.logo_url),
    alt: (0,utils/* currentLanguage */.aS)(company.name),
    width: 250
  }) : /*#__PURE__*/react.createElement("div", {
    style: {
      fontSize: 40,
      fontWeight: 700,
      width: 250,
      textAlign: 'center'
    }
  }, (0,utils/* currentLanguage */.aS)(company.name)), canRetainBadge && /*#__PURE__*/react.createElement("img", {
    src: "https://cdn.retino.com/media/".concat(companyId, "/badges/").concat(lang, "/current/icon.png"),
    width: 250,
    alt: gettext('Effortless returns')
  }))), canRetainBadge !== null && /*#__PURE__*/react.createElement(ui/* Segment */.Y4, {
    padded: true
  }, canRetainBadge ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("h4", {
    className: "text-2xl text-green-600"
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: "badge-check",
    size: "huge"
  }), gettext('This merchant has received the Effortless returns certificate')), /*#__PURE__*/react.createElement("p", {
    className: "mx-auto max-w-xl pt-4 text-gray-600"
  }, gettext("No need to worry to return goods with this merchant. This merchant's customers have been consistently rating the return experience as great here."))) : /*#__PURE__*/react.createElement("h4", {
    className: "text-2xl text-red-600"
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: "ban",
    size: "huge"
  }), gettext('This merchant does not meet the requirements to receive the Effortless returns certificate'))), comments && comments.length > 0 && /*#__PURE__*/react.createElement("p", {
    className: "pt-6 pb-4 text-center text-gray-500"
  }, gettext('Customers that have recently returned something to this store say:'))), comments && comments.length > 0 && /*#__PURE__*/react.createElement(ui/* Card */.Zp, null, comments.map((item, index) => /*#__PURE__*/react.createElement("div", {
    key: "".concat(item.customer_rating_comment, " - ").concat(item.created_at),
    className: "p-5 ".concat(index === 0 ? '' : 'border-t border-gray-300'),
    ref: index === comments.length - 1 ? lastCommentElementRef : null
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-baseline justify-between"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center mb-2"
  }, /*#__PURE__*/react.createElement("strong", {
    className: "pr-2"
  }, gettext('Customer has rated')), /*#__PURE__*/react.createElement(RatingEmoji/* default */.A, {
    rating: item.customer_rating,
    size: "small"
  })), /*#__PURE__*/react.createElement("p", {
    className: "text-gray-600"
  }, moment_default()(item.created_at).format('LL'))), /*#__PURE__*/react.createElement("p", null, item.customer_rating_comment), item.customer_rating_comment_response && /*#__PURE__*/react.createElement("div", {
    className: "mt-4 p-4 bg-gray-100 border border-gray-300 rounded-lg shadow"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center mb-2"
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: "reply",
    className: "text-gray-700 w-5 h-5 mr-2"
  }), /*#__PURE__*/react.createElement("p", {
    className: "font-semibold text-gray-800"
  }, (0,utils/* currentLanguage */.aS)(company.name))), /*#__PURE__*/react.createElement("p", {
    className: "text-gray-800 break-words"
  }, item.customer_rating_comment_response)))), isLoading && /*#__PURE__*/react.createElement("div", {
    className: "align-center p-8 w-full text-center flex justify-center items-center border-t border-gray-300"
  }, /*#__PURE__*/react.createElement(ui/* Loader */.aH, {
    size: "medium"
  }))), /*#__PURE__*/react.createElement("div", {
    className: "mx-auto max-w-lg space-y-3 py-12 text-center"
  }, /*#__PURE__*/react.createElement("p", {
    className: "text-gray-500"
  }, gettext('Effortless returns certificate is given to merchant that is rated 90%+ by their customers in return experience over the past 3 months.')), /*#__PURE__*/react.createElement("p", null, /*#__PURE__*/react.createElement("a", {
    href: "https://www.bezproblemovereklamace.cz/",
    className: "text-blue-700 underline"
  }, gettext('More about the certificate'))), /*#__PURE__*/react.createElement("div", {
    className: "mx-auto w-20 pt-2 text-gray-400"
  }, /*#__PURE__*/react.createElement(LogoIcon/* default */.A, null)))));
}
/* harmony default export */ const badge_BadgeReport = ((0,mobxreact_esm/* observer */.PA)(BadgeReport));
// EXTERNAL MODULE: ./react/components/PaddedLoader.tsx
var PaddedLoader = __webpack_require__(90931);
// EXTERNAL MODULE: ./react/helpers/toast.tsx
var toast = __webpack_require__(15072);
// EXTERNAL MODULE: ./react/public-api/utils.ts
var public_api_utils = __webpack_require__(86063);
;// ./react/client/CustomerPaidShippingRating/index.tsx
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }









function CustomerPaidShippingRating() {
  const {
    companyId,
    shippingId,
    rating
  } = (0,dist/* useParams */.g)();
  const [ratingQuestions, setRatingQuestions] = (0,react.useState)();
  const [ratingAnswers, setRatingAnswers] = (0,react.useState)();
  const [completed, setCompleted] = (0,react.useState)(false);
  const [errors, setErrors] = (0,react.useState)();
  const api = (0,public_api/* default */.Ay)();
  const load = async () => {
    const oldCPSRating = await api.TransportRatingApi.retrieve({
      company_id: companyId,
      shipping_id: shippingId
    });
    if (oldCPSRating.shipping) {
      setCompleted(true);
    }
    const options = await api.TransportRatingApi.options({
      company_id: companyId,
      shipping_id: shippingId
    });
    setRatingQuestions(options.actions.POST);
    setRatingAnswers({
      rating_satisfaction: Number(rating),
      shipping: shippingId
    });
  };
  const [handleLoad, isLoading] = (0,hooks/* useAsyncFunction */.m_)(load);
  const submit = async () => {
    try {
      await api.TransportShippingRatingApi.create({
        request: ratingAnswers
      });
      setCompleted(true);
      toast/* default */.A.success(gettext('Thank you for your feedback.'), {
        title: gettext('Feedback successfully saved')
      });
    } catch (error) {
      if ((0,public_api_utils/* isResponse */.S)(error) && error.response.status === 400) {
        setErrors(await (0,public_api_utils/* getErrors */.Y)(error));
        toast/* default */.A.errorBadRequest();
      } else {
        toast/* default */.A.error();
      }
    }
  };
  const [handleSubmit, isSubmitting] = (0,hooks/* useAsyncFunction */.m_)(submit);
  (0,react.useEffect)(() => {
    handleLoad();
  }, []);
  if (!ratingQuestions || isLoading) {
    return /*#__PURE__*/react.createElement(PaddedLoader/* default */.A, null);
  }
  if (completed) {
    return /*#__PURE__*/react.createElement("div", {
      className: "flex content-center justify-center"
    }, /*#__PURE__*/react.createElement(ui/* Segment */.Y4, {
      padded: true
    }, /*#__PURE__*/react.createElement("h4", {
      style: {
        padding: '0 5rem'
      }
    }, "D\u011Bkujeme v\xE1m za hodnocen\xED.")));
  }
  return /*#__PURE__*/react.createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/react.createElement(ui/* Segment */.Y4, {
    style: {
      marginTop: '2rem',
      maxWidth: '650px'
    }
  }, /*#__PURE__*/react.createElement(ui/* Form */.lV, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/react.createElement(ui/* Form */.lV.Fields, null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Field, {
    label: "Byli jste spokojeni se slu\u017Ebami dopravy?"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-start gap-2 pt-1"
  }, [...Array(3).keys()].reverse().map(idx => /*#__PURE__*/react.createElement("div", {
    onClick: () => setRatingAnswers(old => _objectSpread(_objectSpread({}, old), {}, {
      rating_satisfaction: idx
    })),
    role: "button",
    tabIndex: 0,
    style: {
      opacity: (ratingAnswers === null || ratingAnswers === void 0 ? void 0 : ratingAnswers.rating_satisfaction) === idx ? 1 : 0.15,
      cursor: 'pointer'
    }
  }, /*#__PURE__*/react.createElement(RatingEmoji/* default */.A, {
    rating: idx
  }))))), /*#__PURE__*/react.createElement(ui/* Form */.lV.Field, {
    error: errors === null || errors === void 0 ? void 0 : errors.rating_intuitivity,
    label: "Byl pro v\xE1s proces objedn\xE1n\xED dopravy intuitivn\xED?"
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-1"
  }, ratingQuestions.rating_intuitivity.choices.map(choice => /*#__PURE__*/react.createElement("div", {
    key: choice.value
  }, /*#__PURE__*/react.createElement(ui/* Form */.lV.Radio, {
    name: choice.value,
    label: choice.display_name,
    value: Boolean(ratingAnswers.rating_intuitivity && ratingAnswers.rating_intuitivity === choice.value),
    onChange: () => setRatingAnswers(old => _objectSpread(_objectSpread({}, old), {}, {
      rating_intuitivity: choice.value
    }))
  }))))), /*#__PURE__*/react.createElement(ui/* Form */.lV.Field, {
    error: errors === null || errors === void 0 ? void 0 : errors.rating_shipping_provider_reason,
    label: "Jak\xFD byl d\u016Fvod, \u017Ee jste si zvolili tohoto dopravce?"
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-1"
  }, ratingQuestions.rating_shipping_provider_reason.choices.map(choice => /*#__PURE__*/react.createElement("div", {
    key: choice.value
  }, /*#__PURE__*/react.createElement(ui/* Form */.lV.Radio, {
    label: choice.display_name,
    value: Boolean(ratingAnswers.rating_shipping_provider_reason && ratingAnswers.rating_shipping_provider_reason === choice.value),
    onChange: () => setRatingAnswers(old => _objectSpread(_objectSpread({}, old), {}, {
      rating_shipping_provider_reason: choice.value
    }))
  }))))), ratingAnswers.rating_shipping_provider_reason && ratingAnswers.rating_shipping_provider_reason === 'OTHER' && /*#__PURE__*/react.createElement(ui/* Form */.lV.Textarea, {
    label: "Jak\xFD?",
    error: errors === null || errors === void 0 ? void 0 : errors.shipping_provider_other_reason,
    value: ratingAnswers.shipping_provider_other_reason,
    onChange: value => setRatingAnswers(old => _objectSpread(_objectSpread({}, old), {}, {
      shipping_provider_other_reason: value
    }))
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Field, {
    error: errors === null || errors === void 0 ? void 0 : errors.rating_problems,
    label: "Nastal n\u011Bjak\xFD probl\xE9m s dopravou?"
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-1"
  }, ratingQuestions.rating_problems.choices.map(choice => /*#__PURE__*/react.createElement("div", {
    key: choice.value
  }, /*#__PURE__*/react.createElement(ui/* Form */.lV.Radio, {
    label: choice.display_name,
    value: Boolean(ratingAnswers.rating_problems && ratingAnswers.rating_problems === choice.value),
    onChange: () => setRatingAnswers(old => _objectSpread(_objectSpread({}, old), {}, {
      rating_problems: choice.value
    }))
  }))))), ratingAnswers.rating_problems && ratingAnswers.rating_problems === 'YES' && /*#__PURE__*/react.createElement(ui/* Form */.lV.Textarea, {
    label: "Jak\xFD probl\xE9m nastal?",
    error: errors === null || errors === void 0 ? void 0 : errors.problem_comment,
    value: ratingAnswers.problem_comment,
    onChange: value => setRatingAnswers(old => _objectSpread(_objectSpread({}, old), {}, {
      problem_comment: value
    }))
  }), Boolean(errors) && /*#__PURE__*/react.createElement(ui/* Message */.QB, {
    error: true
  }, "Dopl\u0148te pros\xEDm ozna\u010Den\xE1 chyb\u011Bj\xEDc\xED pole."), /*#__PURE__*/react.createElement("div", {
    className: "flex content-center justify-center"
  }, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    submit: true,
    primary: true,
    loading: isSubmitting
  }, "Odeslat hodnocen\xED"))))));
}
/* harmony default export */ const client_CustomerPaidShippingRating = (CustomerPaidShippingRating);
;// ./react/components/DangerousHTMLContainer.tsx

function DangerousHTMLContainer(_ref) {
  let {
    html
  } = _ref;
  const divRef = (0,react.useRef)(null);
  (0,react.useLayoutEffect)(() => {
    const slotHtml = document.createRange().createContextualFragment(html); // Create a 'tiny' document and parse the html string
    if (divRef && divRef.current) {
      divRef.current.innerHTML = ''; // Clear the container
      divRef.current.appendChild(slotHtml); // Append the new content
    }
  }, [html]);
  return /*#__PURE__*/react.createElement("div", {
    ref: divRef
  });
}
/* harmony default export */ const components_DangerousHTMLContainer = (DangerousHTMLContainer);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js + 1 modules
var misc = __webpack_require__(10146);
;// ./react/helpers/portal.ts



/**
 * Returns the default language for portal integration.
 * If the current UI language is in supported languages, use it.
 * Otherwise, use the first supported language.
 */
const getDefaultPortalLanguage = supportedLanguages => {
  const currentLang = window.appState.lang;
  if (supportedLanguages !== null && supportedLanguages !== void 0 && supportedLanguages.includes(currentLang)) {
    return currentLang;
  }
  return (supportedLanguages === null || supportedLanguages === void 0 ? void 0 : supportedLanguages[0]) || currentLang;
};
const portalCodeTemplate = "<div id=\"{portalId}\" data-company-id=\"{companyId}\" data-language=\"{language}\" data-base-url=\"{baseUrl}\"{dataFormIds}></div>\n<script type=\"text/javascript\" id=\"retino-embedded-form-script\">\n  (function(r,e,t,i,n,o){n=e.createElement(t);n.src=i;n.async=true;o=e.getElementsByTagName(t)[0];o.parentNode.insertBefore(n,o)})(window,document,'script','{staticUrl}embeddedFormInjector.js')\n</script>";
const usePortalCode = (companyId, language, _ref) => {
  let {
    rootId,
    formIds
  } = _ref;
  const portalRootId = (0,react.useRef)(rootId || "retino-portal-".concat((0,misc/* uuid4 */.eJ)().slice(0, 4)));
  const [scriptCode, setScriptCode] = (0,react.useState)('');
  (0,react.useEffect)(() => {
    let dataFormIds = '';
    if ((formIds === null || formIds === void 0 ? void 0 : formIds.length) !== 0) {
      dataFormIds = " data-form-ids=\"".concat((formIds === null || formIds === void 0 ? void 0 : formIds.join(';')) || '', "\"");
    }
    setScriptCode(portalCodeTemplate.replace('{portalId}', portalRootId.current).replace('{companyId}', companyId).replace('{language}', language).replace('{baseUrl}', window.location.origin).replace('{dataFormIds}', dataFormIds).replace('{staticUrl}', window.appState.baseStaticUrl));
  }, [companyId, formIds, language]);
  return scriptCode;
};
const shippingPortalCodeTemplate = "\n<div\n  id=\"{portalId}\"\n  data-company-id=\"{companyId}\"\n  data-language=\"{language}\"\n  data-base-url=\"{baseUrl}\"\n/></div>\n<script type=\"text/javascript\" id=\"retino-shipping-portal-script\">\n  (function(r,e,t,i,n,o){n=e.createElement(t);n.src=i;n.async=true;o=e.getElementsByTagName(t)[0];o.parentNode.insertBefore(n,o)})(window,document,'script','{staticUrl}shipping-portal/injector.js')\n</script>";
const useShippingPortalCode = (companyId, language, _ref2) => {
  let {
    rootId
  } = _ref2;
  const portalRootId = 'shipping-portal';
  const [scriptCode, setScriptCode] = (0,react.useState)('');
  (0,react.useEffect)(() => {
    setScriptCode(shippingPortalCodeTemplate.replace('{portalId}', portalRootId).replace('{companyId}', companyId).replace('{language}', language).replace('{baseUrl}', window.location.origin).replace('{staticUrl}', window.appState.baseStaticUrl));
  }, [companyId, language]);
  return scriptCode;
};
const trackNTraceCodeTemplate = "\n<div\n  id=\"retino-track-n-trace\"\n  data-page-id=\"{pageId}\"\n  data-language=\"{language}\"\n  data-base-url=\"{baseUrl}\"\n></div>\n<script type=\"text/javascript\" id=\"retino-track-n-trace-script\">\n  (function(r,e,t,i,n,o){n=e.createElement(t);n.src=i;n.async=true;o=e.getElementsByTagName(t)[0];o.parentNode.insertBefore(n,o)})(window,document,'script','{staticUrl}trackntraceInjector.js')\n</script>";
const useTrackNTraceCode = (pageId, language) => {
  const [scriptCode, setScriptCode] = (0,react.useState)('');
  (0,react.useEffect)(() => {
    setScriptCode(trackNTraceCodeTemplate.replace('{pageId}', pageId).replace('{language}', language).replace('{baseUrl}', window.location.origin).replace('{staticUrl}', window.appState.baseStaticUrl));
  }, [pageId, language]);
  return scriptCode;
};
;// ./react/client/portal/ClientPortal.tsx





function ClientPortal() {
  const {
    companyId
  } = (0,dist/* useParams */.g)();
  const [searchParams] = (0,react_router_dom_dist/* useSearchParams */.ok)();
  let rootId = 'retino-portal';
  const urlParam = Array.from(searchParams.keys()).find(k => k.startsWith(rootId) && k.endsWith('-url'));
  if (urlParam) {
    rootId = urlParam.substring(0, urlParam.indexOf('-url'));
  }
  const portalCode = usePortalCode(companyId, window.appState.lang, {
    rootId
  });
  return /*#__PURE__*/react.createElement(components_DangerousHTMLContainer, {
    html: portalCode
  });
}
/* harmony default export */ const portal_ClientPortal = (ClientPortal);
;// ./react/client/portal/ClientShippingPortal.tsx





function ClientShippingPortal_ClientPortal() {
  const {
    companyId
  } = (0,dist/* useParams */.g)();
  const [searchParams] = (0,react_router_dom_dist/* useSearchParams */.ok)();
  let rootId = 'shipping-portal';
  const urlParam = Array.from(searchParams.keys()).find(k => k.startsWith(rootId) && k.endsWith('-url'));
  if (urlParam) {
    rootId = urlParam.substring(0, urlParam.indexOf('-url'));
  }
  const portalCode = useShippingPortalCode(companyId, window.appState.lang, {
    rootId
  });
  return /*#__PURE__*/react.createElement(components_DangerousHTMLContainer, {
    html: portalCode
  });
}
/* harmony default export */ const ClientShippingPortal = (ClientShippingPortal_ClientPortal);
;// ./react/client/ShippingRating/index.tsx
function ShippingRating_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ShippingRating_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ShippingRating_ownKeys(Object(t), !0).forEach(function (r) { ShippingRating_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ShippingRating_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ShippingRating_defineProperty(obj, key, value) { key = ShippingRating_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function ShippingRating_toPropertyKey(t) { var i = ShippingRating_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function ShippingRating_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }









function ShippingRating() {
  const {
    companyId,
    shippingId,
    rating
  } = (0,dist/* useParams */.g)();
  const [ratingQuestions, setRatingQuestions] = (0,react.useState)();
  const [ratingAnswers, setRatingAnswers] = (0,react.useState)();
  const [completed, setCompleted] = (0,react.useState)(false);
  const [errors, setErrors] = (0,react.useState)();
  const api = (0,public_api/* default */.Ay)();
  const load = async () => {
    try {
      const oldCPSRating = await api.ShippingRatingApi.retrieve({
        company_id: companyId,
        shipping_id: shippingId
      });
      if (oldCPSRating.shipping) {
        setCompleted(true);
      }
    } catch (error) {
      if (!((0,public_api_utils/* isResponse */.S)(error) && error.response.status === 404)) {
        toast/* default */.A.error();
      }
    }
    const options = await api.ShippingRatingApi.options({
      company_id: companyId,
      shipping_id: shippingId
    });
    setRatingQuestions(options.actions.POST);
    setRatingAnswers({
      rating_satisfaction: Number(rating),
      shipping: shippingId
    });
  };
  const [handleLoad, isLoading] = (0,hooks/* useAsyncFunction */.m_)(load);
  const submit = async () => {
    try {
      await api.ShippingRatingApi.create({
        request: ratingAnswers,
        shipping_id: shippingId,
        company_id: companyId
      });
      setCompleted(true);
      toast/* default */.A.success(gettext('Thank you for your feedback.'), {
        title: gettext('Feedback successfully saved')
      });
    } catch (error) {
      if ((0,public_api_utils/* isResponse */.S)(error) && error.response.status === 400) {
        setErrors(await (0,public_api_utils/* getErrors */.Y)(error));
        toast/* default */.A.errorBadRequest();
      } else {
        toast/* default */.A.error();
      }
    }
  };
  const [handleSubmit, isSubmitting] = (0,hooks/* useAsyncFunction */.m_)(submit);
  (0,react.useEffect)(() => {
    handleLoad();
  }, []);
  if (!ratingQuestions || isLoading) {
    return /*#__PURE__*/react.createElement(PaddedLoader/* default */.A, null);
  }
  if (completed) {
    return /*#__PURE__*/react.createElement("div", {
      className: "flex content-center justify-center"
    }, /*#__PURE__*/react.createElement(ui/* Segment */.Y4, {
      padded: true
    }, /*#__PURE__*/react.createElement("h4", {
      style: {
        padding: '0 5rem'
      }
    }, gettext('Thank you for your rating.'))));
  }
  return /*#__PURE__*/react.createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/react.createElement(ui/* Segment */.Y4, {
    style: {
      marginTop: '2rem',
      maxWidth: '650px'
    }
  }, /*#__PURE__*/react.createElement(ui/* Form */.lV, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/react.createElement(ui/* Form */.lV.Fields, null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Field, {
    label: gettext('Were you satisfied with the transportation services?')
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-start gap-2 pt-1"
  }, [...Array(3).keys()].reverse().map(idx => /*#__PURE__*/react.createElement("div", {
    onClick: () => setRatingAnswers(old => ShippingRating_objectSpread(ShippingRating_objectSpread({}, old), {}, {
      rating_satisfaction: idx
    })),
    role: "button",
    tabIndex: 0,
    style: {
      opacity: (ratingAnswers === null || ratingAnswers === void 0 ? void 0 : ratingAnswers.rating_satisfaction) === idx ? 1 : 0.15,
      cursor: 'pointer'
    }
  }, /*#__PURE__*/react.createElement(RatingEmoji/* default */.A, {
    rating: idx
  }))))), /*#__PURE__*/react.createElement(ui/* Form */.lV.Field, {
    error: errors === null || errors === void 0 ? void 0 : errors.rating_intuitivity,
    label: gettext('Was the process of ordering transportation intuitive for you?')
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-1"
  }, ratingQuestions.rating_intuitivity.choices.map(choice => /*#__PURE__*/react.createElement("div", {
    key: choice.value
  }, /*#__PURE__*/react.createElement(ui/* Form */.lV.Radio, {
    name: choice.value,
    label: choice.display_name,
    value: Boolean(ratingAnswers.rating_intuitivity && ratingAnswers.rating_intuitivity === choice.value),
    onChange: () => setRatingAnswers(old => ShippingRating_objectSpread(ShippingRating_objectSpread({}, old), {}, {
      rating_intuitivity: choice.value
    }))
  }))))), /*#__PURE__*/react.createElement(ui/* Form */.lV.Field, {
    error: errors === null || errors === void 0 ? void 0 : errors.rating_problems,
    label: gettext('Has any problem occurred with the transportation?')
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-1"
  }, ratingQuestions.rating_problems.choices.map(choice => /*#__PURE__*/react.createElement("div", {
    key: choice.value
  }, /*#__PURE__*/react.createElement(ui/* Form */.lV.Radio, {
    label: choice.display_name,
    value: Boolean(ratingAnswers.rating_problems && ratingAnswers.rating_problems === choice.value),
    onChange: () => setRatingAnswers(old => ShippingRating_objectSpread(ShippingRating_objectSpread({}, old), {}, {
      rating_problems: choice.value
    }))
  }))))), ratingAnswers.rating_problems && ratingAnswers.rating_problems === 'YES' && /*#__PURE__*/react.createElement(ui/* Form */.lV.Textarea, {
    label: gettext('What problem has occurred?'),
    error: errors === null || errors === void 0 ? void 0 : errors.problem_comment,
    value: ratingAnswers.problem_comment,
    onChange: value => setRatingAnswers(old => ShippingRating_objectSpread(ShippingRating_objectSpread({}, old), {}, {
      problem_comment: value
    }))
  }), Boolean(errors) && /*#__PURE__*/react.createElement(ui/* Message */.QB, {
    error: true
  }, gettext('Please fill out missing fields.')), /*#__PURE__*/react.createElement("div", {
    className: "flex content-center justify-center"
  }, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    submit: true,
    primary: true,
    loading: isSubmitting
  }, gettext('Send rating')))))));
}
/* harmony default export */ const client_ShippingRating = (ShippingRating);
// EXTERNAL MODULE: ./node_modules/interweave/esm/index.js + 1 modules
var interweave_esm = __webpack_require__(54087);
// EXTERNAL MODULE: ./react/components/form-controls/FileUploadField.tsx + 7 modules
var FileUploadField = __webpack_require__(44492);
// EXTERNAL MODULE: ./react/ui/rich-text-editor/RichTextEditor.tsx + 1 modules
var RichTextEditor = __webpack_require__(41379);
// EXTERNAL MODULE: ./react/api/codegen/index.ts
var codegen = __webpack_require__(29268);
// EXTERNAL MODULE: ./react/components/EllipsisButton.tsx
var EllipsisButton = __webpack_require__(83073);
;// ./react/client/TicketDetail/Communication/MessageUser.tsx
/* eslint-disable react/function-component-definition */









const Message = _ref => {
  let {
    message,
    ticket
  } = _ref;
  const [expandMessage, setExpandMessage] = (0,react.useState)(false);
  const {
    company
  } = usePublicCompany();
  return /*#__PURE__*/react.createElement(ui/* Feed */.JY.Event, {
    key: message.id,
    icon: message.type === codegen/* BackendEnums */.f.MessageListTypeEnum.CUSTOMER_MESSAGE ? 'user' : 'shopping-cart',
    color: message.type === codegen/* BackendEnums */.f.MessageListTypeEnum.CUSTOMER_MESSAGE ? 'red' : 'blue',
    feedIconRingColor: "ring-gray-50",
    renderChildren: children => /*#__PURE__*/react.createElement(ui/* Card */.Zp, {
      flat: true
    }, /*#__PURE__*/react.createElement(ui/* Card */.Zp.Content, null, children))
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("span", {
    className: "font-medium"
  }, message.type === codegen/* BackendEnums */.f.MessageListTypeEnum.CUSTOMER_MESSAGE ? ticket.customer_name : (0,utils/* currentLanguage */.aS)(company === null || company === void 0 ? void 0 : company.name)), /*#__PURE__*/react.createElement("div", {
    className: "text-sm text-gray-500"
  }, /*#__PURE__*/react.createElement(ui/* Popup */.zD, {
    on: "hover",
    trigger: /*#__PURE__*/react.createElement("span", null, moment_default()(message.created_at).fromNow())
  }, /*#__PURE__*/react.createElement("div", {
    className: "whitespace-nowrap p-2"
  }, moment_default()(message.created_at).format('LLL'))))), message.additional_text ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("p", null, /*#__PURE__*/react.createElement(interweave_esm/* Interweave */.BW, {
    content: message.text
  })), /*#__PURE__*/react.createElement(EllipsisButton/* default */.A, {
    onClick: () => setExpandMessage(!expandMessage),
    size: "tiny"
  }), !!expandMessage && /*#__PURE__*/react.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/react.createElement(interweave_esm/* Interweave */.BW, {
    content: message.additional_text
  }))) : /*#__PURE__*/react.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/react.createElement(interweave_esm/* Interweave */.BW, {
    content: message.text
  })), !!(message.files_data && message.files_data.length) && /*#__PURE__*/react.createElement("div", {
    className: "space-y-1"
  }, message.files_data && message.files_data.map(file => /*#__PURE__*/react.createElement("div", {
    key: "file-".concat(file.id)
  }, /*#__PURE__*/react.createElement("a", {
    href: file.file,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "text-blue-700",
    download: file.filename
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: "paper-clip"
  }), " ", file.filename))))));
};
/* harmony default export */ const MessageUser = ((0,mobxreact_esm/* observer */.PA)(Message));
;// ./react/client/TicketDetail/Communication/index.tsx











function Communication(_ref) {
  let {
    ticket,
    onSend
  } = _ref;
  const [message, setMessage] = (0,react.useState)('');
  const [messagePreview, setMessagePreview] = (0,react.useState)(null);
  const [files, setFiles] = (0,react.useState)([]);
  const [isFileUploading, setIsFileUploading] = (0,react.useState)(false);
  const [isEditorLoading, setIsEditorLoading] = (0,react.useState)(true);
  const [errors, setErrors] = (0,react.useState)({});
  const hiddenFileInput = (0,react.useRef)(null);
  const [fileUploadInitialized, setFileUploadInitialized] = (0,react.useState)(false);
  const editorRef = (0,react.useRef)();
  const fileUploadFieldRef = (0,react.useRef)();
  const api = (0,public_api/* default */.Ay)();
  const sendMessage = async () => {
    setErrors({});
    setMessagePreview(message);
    try {
      var _editorRef$current;
      await api.ClientTicketMessagesApi.create({
        id: ticket.id,
        request: {
          text: message,
          files
        }
      });
      if (onSend) {
        await onSend();
      }
      setMessagePreview(null);
      (_editorRef$current = editorRef.current) === null || _editorRef$current === void 0 || _editorRef$current.execCommand('mceSetContent', false, '');
      setFiles([]);
    } catch (error) {
      if ((0,public_api_utils/* isResponse */.S)(error) && error.response.status === 400) {
        const respErrors = await (0,public_api_utils/* getErrors */.Y)(error);
        setErrors(respErrors);
        toast/* default */.A.errorBadRequest();
      } else {
        toast/* default */.A.error();
      }
    }
  };
  const [handleSendMessage, isSending] = (0,hooks/* useAsyncFunction */.m_)(sendMessage);
  (0,react.useEffect)(() => {
    if (fileUploadFieldRef.current) {
      setFileUploadInitialized(true);
    }
  }, [fileUploadFieldRef.current]);
  const handleFileInputChange = event => {
    var _event$target$files;
    if (!fileUploadFieldRef.current) return;
    const filesArray = Array.from((_event$target$files = event.target.files) !== null && _event$target$files !== void 0 ? _event$target$files : []);
    filesArray.forEach(file => {
      var _fileUploadFieldRef$c;
      (_fileUploadFieldRef$c = fileUploadFieldRef.current) === null || _fileUploadFieldRef$c === void 0 || _fileUploadFieldRef$c.handleFileUpload(file);
    });
  };
  return /*#__PURE__*/react.createElement(ui/* Feed */.JY, null, /*#__PURE__*/react.createElement(ui/* Feed */.JY.Event, {
    key: ticket.id,
    icon: "chat-alt-2",
    feedIconRingColor: "ring-gray-50",
    color: "gray",
    renderChildren: children => /*#__PURE__*/react.createElement("div", {
      className: "contents",
      role: "presentation"
    }, /*#__PURE__*/react.createElement(ui/* Card */.Zp, {
      flat: true
    }, /*#__PURE__*/react.createElement(ui/* Card */.Zp.Content, null, children)))
  }, /*#__PURE__*/react.createElement(ui/* Form */.lV, {
    onSubmit: () => handleSendMessage()
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, isEditorLoading && /*#__PURE__*/react.createElement(PaddedLoader/* default */.A, null), /*#__PURE__*/react.createElement("div", {
    className: "relative flex-grow border ".concat(isEditorLoading ? 'hidden' : '')
  }, fileUploadFieldRef.current && /*#__PURE__*/react.createElement(RichTextEditor/* default */.A, {
    onChange: setMessage,
    placeholder: gettext('Write a message...'),
    customActions: [{
      key: 'fileupload',
      onClick: () => {
        var _hiddenFileInput$curr;
        return (_hiddenFileInput$curr = hiddenFileInput.current) === null || _hiddenFileInput$curr === void 0 ? void 0 : _hiddenFileInput$curr.click();
      },
      icon: 'paper-clip',
      label: gettext('File upload')
    }],
    onLoad: () => setIsEditorLoading(false),
    onInit: (evt, editor) => {
      editorRef.current = editor;
    },
    onDrop: event => {
      event.preventDefault();
      event.stopPropagation();
      if (!event.dataTransfer || !fileUploadFieldRef.current) return;
      const filesArray = Array.from(event.dataTransfer.files);
      filesArray.forEach(file => {
        var _fileUploadFieldRef$c2;
        (_fileUploadFieldRef$c2 = fileUploadFieldRef.current) === null || _fileUploadFieldRef$c2 === void 0 || _fileUploadFieldRef$c2.handleFileUpload(file);
      });
    },
    onPaste: event => {
      var _event$clipboardData;
      const filesArray = Array.from((_event$clipboardData = event.clipboardData) === null || _event$clipboardData === void 0 ? void 0 : _event$clipboardData.files);
      if (filesArray.length > 0) {
        event.preventDefault();
        event.stopPropagation();
        if (fileUploadFieldRef.current) {
          filesArray.forEach(file => {
            var _fileUploadFieldRef$c3;
            (_fileUploadFieldRef$c3 = fileUploadFieldRef.current) === null || _fileUploadFieldRef$c3 === void 0 || _fileUploadFieldRef$c3.handleFileUpload(file);
          });
        }
      }
    }
  }), errors && errors.text && /*#__PURE__*/react.createElement("div", {
    className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
  }, /*#__PURE__*/react.createElement("svg", {
    className: "h-5 w-5 text-red-500",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  })))), /*#__PURE__*/react.createElement(FileUploadField/* default */.A, {
    ref: fileUploadFieldRef,
    value: files,
    onChange: value => setFiles(value),
    setIsLoading: value => setIsFileUploading(value),
    render: _ref2 => {
      let {
        fileList
      } = _ref2;
      return /*#__PURE__*/react.createElement("div", {
        className: "space-y-4"
      }, /*#__PURE__*/react.createElement("div", {
        className: "".concat(isSending && 'cursor-wait opacity-30')
      }, fileList), /*#__PURE__*/react.createElement("div", {
        className: "flex flex-wrap items-center justify-end gap-x-4 gap-y-2"
      }, isFileUploading ? /*#__PURE__*/react.createElement(ui/* Popup */.zD, {
        on: "hover",
        position: "bottom right",
        trigger: /*#__PURE__*/react.createElement(ui/* Button */.$n, {
          primary: true,
          disabled: true
        }, gettext('Send message'))
      }, /*#__PURE__*/react.createElement("span", {
        className: "whitespace-nowrap text-sm text-gray-600"
      }, gettext('Files are still uploading... Please wait.'))) : /*#__PURE__*/react.createElement(ui/* Button */.$n, {
        primary: true,
        submit: true,
        loading: isSending
      }, gettext('Send message'))));
    }
  })), /*#__PURE__*/react.createElement("input", {
    type: "file",
    ref: hiddenFileInput,
    onChange: handleFileInputChange,
    style: {
      display: 'none'
    },
    multiple: true
  }))), messagePreview && /*#__PURE__*/react.createElement(ui/* Feed */.JY.Event, {
    icon: "user",
    color: "red",
    feedIconRingColor: "ring-gray-50",
    renderChildren: children => /*#__PURE__*/react.createElement("div", {
      className: "pointer-events-none animate-pulse cursor-wait opacity-30"
    }, /*#__PURE__*/react.createElement(ui/* Card */.Zp, {
      flat: true
    }, /*#__PURE__*/react.createElement(ui/* Card */.Zp.Content, null, children)))
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("span", {
    className: "font-medium"
  }, ticket.customer_name), /*#__PURE__*/react.createElement("div", {
    className: "text-sm text-gray-500"
  }, gettext('Sending message...'))), /*#__PURE__*/react.createElement("p", {
    className: "mb-0"
  }, /*#__PURE__*/react.createElement(interweave_esm/* Interweave */.BW, {
    content: messagePreview
  })))), ticket.messages.map(message => /*#__PURE__*/react.createElement(MessageUser, {
    key: message.id,
    ticket: ticket,
    message: message
  })));
}
/* harmony default export */ const TicketDetail_Communication = (Communication);
;// ./react/client/TicketDetail/Header/Step.tsx

function Step(props) {
  return /*#__PURE__*/react.createElement("span", {
    className: "ml-4 text-sm font-medium"
  }, props.children);
}
/* harmony default export */ const Header_Step = (Step);
;// ./react/client/TicketDetail/Header/StepGroup.tsx

function StepGroup(_ref) {
  let {
    children
  } = _ref;
  const activeIndex = children.findIndex(child => child.props.active === true);
  return /*#__PURE__*/react.createElement("ol", {
    className: "divide-y divide-gray-300 md:flex md:divide-y-0 md:flex-wrap md:justify-center"
  }, children.map((child, index) => {
    const isActive = index <= activeIndex;
    const color = isActive ? 'text-blue-700' : 'text-gray-400';
    return /*#__PURE__*/react.createElement("li", {
      className: "relative md:flex ".concat(color, " md:max-h-10"),
      key: "step-".concat(index)
    }, /*#__PURE__*/react.createElement("span", {
      className: "group flex items-center"
    }, /*#__PURE__*/react.createElement("span", {
      className: "".concat(index === 0 ? 'px-4 md:pl-0' : 'px-4', " flex items-center py-3 text-sm font-medium")
    }, isActive ? /*#__PURE__*/react.createElement("span", {
      className: "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-blue-600"
    }, /*#__PURE__*/react.createElement("svg", {
      className: "h-4 w-4 text-white",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true"
    }, /*#__PURE__*/react.createElement("path", {
      fillRule: "evenodd",
      d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
      clipRule: "evenodd"
    }))) : /*#__PURE__*/react.createElement("span", {
      className: "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-gray-200 text-white"
    }, /*#__PURE__*/react.createElement("svg", {
      className: "h-4 w-4 text-white",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor"
    }, /*#__PURE__*/react.createElement("path", {
      fillRule: "evenodd",
      d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
      clipRule: "evenodd"
    }))), /*#__PURE__*/react.createElement("div", {
      className: "contents"
    }, child))), index !== children.length - 1 && /*#__PURE__*/react.createElement("div", {
      className: "hidden h-full w-5 md:block",
      "aria-hidden": "true"
    }, /*#__PURE__*/react.createElement("svg", {
      className: "h-full w-full text-gray-300",
      viewBox: "0 0 22 80",
      fill: "none",
      preserveAspectRatio: "none"
    }, /*#__PURE__*/react.createElement("path", {
      d: "M0 -2L20 40L0 82",
      vectorEffect: "non-scaling-stroke",
      stroke: "currentcolor",
      strokeLinejoin: "round"
    }))));
  }));
}
/* harmony default export */ const Header_StepGroup = (StepGroup);
;// ./react/client/TicketDetail/Header/index.tsx
/* provided dependency */ var Header_moment = __webpack_require__(95093);







function Header(_ref) {
  var _ticket$order_id, _company$company;
  let {
    ticket,
    steps
  } = _ref;
  const company = usePublicCompany();
  return /*#__PURE__*/react.createElement(ui/* Card */.Zp, {
    flat: true
  }, /*#__PURE__*/react.createElement(ui/* Card */.Zp.Content, null, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-3"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("h2", {
    className: "text-2xl font-medium"
  }, (0,utils/* currentLanguage */.aS)(ticket.type), " ", ticket.code)), /*#__PURE__*/react.createElement("div", {
    className: "flex flex-wrap items-center gap-4 text-gray-600 md:gap-12"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-1 text-sm"
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    size: "small",
    name: "user",
    color: "gray",
    solid: true,
    colorIntensity: 600
  }), /*#__PURE__*/react.createElement("span", null, ticket.customer_name)), /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-1 text-sm"
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    size: "small",
    name: "shopping-cart",
    color: "gray",
    solid: true,
    colorIntensity: 600
  }), /*#__PURE__*/react.createElement("span", null, (_ticket$order_id = ticket.order_id) !== null && _ticket$order_id !== void 0 ? _ticket$order_id : gettext('Ticket without order'))), /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-1 text-sm"
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    size: "small",
    name: "calendar",
    color: "gray",
    solid: true,
    colorIntensity: 600
  }), /*#__PURE__*/react.createElement(ui/* Popup */.zD, {
    on: "hover",
    trigger: /*#__PURE__*/react.createElement("span", null, Header_moment(ticket.created_at).fromNow())
  }, /*#__PURE__*/react.createElement("span", {
    className: "whitespace-nowrap"
  }, Header_moment(ticket.created_at).format('ll')))))), ticket.closed_at ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ui/* Message */.QB, {
    warning: true
  }, /*#__PURE__*/react.createElement("strong", null, gettext('This ticket is closed.'))), ticket.customer_rating && /*#__PURE__*/react.createElement(ui/* Card */.Zp, {
    flat: true
  }, /*#__PURE__*/react.createElement("div", {
    className: "p-5"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-baseline justify-between"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center mb-2"
  }, /*#__PURE__*/react.createElement("strong", {
    className: "pr-2"
  }, gettext('Your rating')), /*#__PURE__*/react.createElement(RatingEmoji/* default */.A, {
    rating: ticket.customer_rating,
    size: "small"
  }))), /*#__PURE__*/react.createElement("p", null, ticket.customer_rating_comment), ticket.customer_rating_comment_response && /*#__PURE__*/react.createElement("div", {
    className: "mt-4 p-4 bg-gray-100 border border-gray-300 rounded-lg shadow"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center mb-2"
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: "reply",
    className: "text-gray-700 w-5 h-5 mr-2"
  }), /*#__PURE__*/react.createElement("p", {
    className: "font-semibold text-gray-800"
  }, (0,utils/* currentLanguage */.aS)((_company$company = company.company) === null || _company$company === void 0 ? void 0 : _company$company.name))), /*#__PURE__*/react.createElement("p", {
    className: "text-gray-800"
  }, ticket.customer_rating_comment_response))))) : steps && /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(Header_StepGroup, null, steps.map(step => /*#__PURE__*/react.createElement(Header_Step, {
    key: step.id,
    active: ticket.process_step === step.id
  }, (0,utils/* currentLanguage */.aS)(step.name))))))));
}
/* harmony default export */ const TicketDetail_Header = (Header);
// EXTERNAL MODULE: ./react/tickets/detail/components/aside/Aside/Products/ProductCustomFieldValue.tsx
var ProductCustomFieldValue = __webpack_require__(77126);
;// ./react/client/TicketDetail/Products/Product.tsx





function Product(_ref) {
  let {
    product,
    ticket,
    productCustomFieldTypes
  } = _ref;
  return /*#__PURE__*/react.createElement(ui/* Card */.Zp, {
    flat: true
  }, /*#__PURE__*/react.createElement(ui/* Card */.Zp.Content, null, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-wrap gap-x-4 gap-y-2"
  }, product.image_url && /*#__PURE__*/react.createElement("div", {
    className: "flex-grow-0"
  }, /*#__PURE__*/react.createElement("img", {
    src: product.image_url,
    alt: product.image_name || product.name,
    className: "h-32 w-32 rounded-lg object-contain"
  })), /*#__PURE__*/react.createElement("div", {
    className: "flex-grow space-y-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-wrap justify-between gap-1"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex text-lg"
  }, product.amount && /*#__PURE__*/react.createElement("span", {
    className: "mr-1.5"
  }, "".concat(product.amount, "\xD7 ")), /*#__PURE__*/react.createElement("h3", {
    className: "font-medium"
  }, product.name), !!product.variant && /*#__PURE__*/react.createElement("span", {
    className: "ml-3 text-gray-500"
  }, product.variant)), !!product.price && /*#__PURE__*/react.createElement("div", {
    className: "font-medium text-gray-500"
  }, (0,utils/* formatPrice */.$g)(product.price, ticket.currency))), /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, productCustomFieldTypes.map(field => product.custom_fields[field.id] && /*#__PURE__*/react.createElement(ProductCustomFieldValue/* default */.A, {
    customField: field,
    customFields: product.custom_fields
  })))))));
}
/* harmony default export */ const Products_Product = ((0,mobxreact_esm/* observer */.PA)(Product));
;// ./react/client/TicketDetail/Products/ProductsCardLoader.tsx


function ProductsCardLoader() {
  return /*#__PURE__*/react.createElement(ui/* Card */.Zp, {
    flat: true
  }, /*#__PURE__*/react.createElement(ui/* Card */.Zp.Content, null, /*#__PURE__*/react.createElement("div", {
    className: "relative flex flex-wrap gap-x-4 gap-y-2"
  }, /*#__PURE__*/react.createElement("div", {
    className: "h-32 w-32 flex-grow-0 animate-pulse rounded-lg bg-gray-100"
  }), /*#__PURE__*/react.createElement("div", {
    className: "flex-grow space-y-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-wrap justify-between gap-1"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex h-12 w-1/2 animate-pulse rounded-lg bg-gray-100"
  })), /*#__PURE__*/react.createElement("div", {
    className: "h-16 w-3/4 animate-pulse space-y-4 rounded-lg bg-gray-100"
  })))));
}
/* harmony default export */ const Products_ProductsCardLoader = (ProductsCardLoader);
;// ./react/client/TicketDetail/Products/index.tsx




function Products(_ref) {
  let {
    ticket,
    products
  } = _ref;
  const [productCustomFieldTypes, setProductCustomFieldTypes] = (0,react.useState)(null);
  const api = (0,public_api/* default */.Ay)();
  (0,react.useEffect)(() => {
    (async () => {
      const response = await api.ClientTicketProductCustomFieldTypesApi.list({
        id: ticket.id
      });
      setProductCustomFieldTypes(response);
    })();
  }, [api.ClientTicketProductCustomFieldTypesApi, ticket.id]);
  if (products.length === 0) return null;
  if (productCustomFieldTypes === null) return /*#__PURE__*/react.createElement(Products_ProductsCardLoader, null);
  return /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, products.map(product => /*#__PURE__*/react.createElement(Products_Product, {
    key: product.id,
    product: product,
    ticket: ticket,
    productCustomFieldTypes: productCustomFieldTypes
  })));
}
/* harmony default export */ const TicketDetail_Products = (Products);
// EXTERNAL MODULE: ./react/components/Coupon/Coupon.tsx
var Coupon = __webpack_require__(38037);
// EXTERNAL MODULE: ./react/routes/codegen/clientRoutes.ts
var clientRoutes = __webpack_require__(82085);
;// ./react/client/TicketDetail/Remarketing/CallRequestModal.tsx





function CallRequestModal(_ref) {
  let {
    remarketingSettingsId,
    ticket,
    open,
    onClose,
    onSuccess
  } = _ref;
  const publicApi = (0,public_api/* default */.Ay)();
  const [phoneNumber, setPhoneNumber] = (0,react.useState)('');
  const [error, setError] = (0,react.useState)();
  const [handleSubmit, isSubmitting] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    try {
      const response = await publicApi.MarketplaceRemarketingCallRequestApi.create({
        settings_id: remarketingSettingsId,
        request: {
          ticket_id: ticket.id,
          phone_number: phoneNumber
        }
      });
      onSuccess(response.phone_number);
    } catch (e) {
      if ((0,public_api_utils/* isResponse */.S)(e) && e.response.status === 400) {
        setError(await (0,public_api_utils/* getErrors */.Y)(e));
      }
    }
  });
  return /*#__PURE__*/react.createElement(ui/* Modal */.aF, {
    size: "md",
    open: open,
    dismissible: true,
    onClose: onClose
  }, /*#__PURE__*/react.createElement(ui/* Modal */.aF.Content, null, /*#__PURE__*/react.createElement(ui/* Form */.lV, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    label: gettext('Fill in your phone number'),
    type: "tel",
    name: "phone",
    value: phoneNumber,
    onChange: setPhoneNumber,
    error: error === null || error === void 0 ? void 0 : error.phone_number
  }), /*#__PURE__*/react.createElement("div", {
    className: "mt-4 flex justify-between gap-2"
  }, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    onClick: onClose
  }, gettext('Close')), /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    loading: isSubmitting,
    primary: true,
    submit: true,
    icon: "phone",
    iconSolid: true
  }, gettext('Call me'))))));
}
/* harmony default export */ const Remarketing_CallRequestModal = (CallRequestModal);
;// ./react/client/TicketDetail/Remarketing/index.tsx









function Remarketing(_ref) {
  var _ticket$voucher, _getTicketVoucherSett, _getTicketVoucherSett2;
  let {
    ticket
  } = _ref;
  const publicApi = (0,public_api/* default */.Ay)();
  const {
    company
  } = usePublicCompany();
  const [settings, setSettings] = (0,react.useState)();
  const [callRequested, setCallRequested] = (0,react.useState)(ticket.call_requested);
  const [phoneNumber, setPhoneNumber] = (0,react.useState)(ticket.customer_phone);
  const [callRequestModalOpen, setCallRequestModalOpen] = (0,react.useState)(false);
  const [loadRemarketing] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    setSettings(await publicApi.MarketplaceRemarketingSettingsApi.retrieve({
      ticket_id: ticket.id
    }));
  });
  const [requestCall, isLoadingRequestCall] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    if (ticket.customer_phone && settings) {
      await publicApi.MarketplaceRemarketingCallRequestApi.create({
        settings_id: settings.id,
        request: {
          ticket_id: ticket.id
        }
      });
      setCallRequested(true);
    } else {
      setCallRequestModalOpen(true);
    }
  });
  (0,react.useEffect)(() => {
    if (ticket) {
      loadRemarketing();
    }
  }, [ticket]);
  if (!settings) {
    return null;
  }
  const getTicketVoucherSettings = () => {
    var _settings$voucher_set;
    return settings === null || settings === void 0 || (_settings$voucher_set = settings.voucher_settings) === null || _settings$voucher_set === void 0 ? void 0 : _settings$voucher_set[ticket.currency];
  };
  const getExpirationDate = () => {
    if (ticket.voucher) {
      return ticket.voucher.valid_to ? new Date(ticket.voucher.valid_to) : null;
    }
    const voucherSettings = getTicketVoucherSettings();
    if (!(voucherSettings !== null && voucherSettings !== void 0 && voucherSettings.expiration_days)) {
      return null;
    }
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + voucherSettings.expiration_days);
    return expirationDate;
  };
  const displayCallRequest = !ticket.closed_at && settings.call_request_in_ticket_detail && settings.call_request_text;
  const displayBanner = settings.banner_in_ticket_detail && settings.banner_url && settings.banner_image;
  const displayVoucher = ticket.voucher || settings.can_create_voucher;
  return /*#__PURE__*/react.createElement(react.Fragment, null, displayVoucher && /*#__PURE__*/react.createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/react.createElement(Coupon/* default */.A, {
    ticketId: ticket.id,
    remarketingSettingsId: settings.id,
    shopName: (0,utils/* currentLanguage */.aS)(company === null || company === void 0 ? void 0 : company.name),
    color: "#4F46E5",
    textColor: "#FFFFFF",
    voucherCode: (_ticket$voucher = ticket.voucher) === null || _ticket$voucher === void 0 ? void 0 : _ticket$voucher.code,
    value: ticket.voucher ? ticket.voucher.amount : parseFloat((_getTicketVoucherSett = getTicketVoucherSettings()) === null || _getTicketVoucherSett === void 0 ? void 0 : _getTicketVoucherSett.value),
    currency: ticket.voucher ? ticket.voucher.currency : ticket.currency,
    expirationDate: getExpirationDate(),
    min_price: ticket.voucher && 'min_price' in ticket.voucher ? ticket.voucher.min_price : (_getTicketVoucherSett2 = getTicketVoucherSettings()) === null || _getTicketVoucherSett2 === void 0 ? void 0 : _getTicketVoucherSett2.min_order_value
  })), displayCallRequest && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ui/* Card */.Zp, {
    flat: true
  }, /*#__PURE__*/react.createElement("div", {
    className: "p-6"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-base font-medium leading-7 text-gray-900"
  }, /*#__PURE__*/react.createElement("span", null, gettext('Should we call you?'))), !callRequested && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    className: "mt-1 text-sm text-gray-500"
  }, (0,utils/* currentLanguage */.aS)(settings.call_request_text)), /*#__PURE__*/react.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    onClick: requestCall,
    icon: "phone",
    iconSolid: true,
    loading: isLoadingRequestCall
  }, gettext('Call me')))), callRequested && /*#__PURE__*/react.createElement("div", {
    className: "mt-2 flex items-center text-sm text-gray-500"
  }, /*#__PURE__*/react.createElement("div", {
    className: "mr-2 flex h-4 w-4 items-center text-green-600"
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: "check",
    size: "tiny",
    fitted: true
  })), gettext('We have received your request and our agents will contact you soon on this phone number'), ":", /*#__PURE__*/react.createElement("span", {
    className: "ml-1 font-bold"
  }, phoneNumber)))), /*#__PURE__*/react.createElement(Remarketing_CallRequestModal, {
    remarketingSettingsId: settings.id,
    ticket: ticket,
    open: callRequestModalOpen,
    onClose: () => setCallRequestModalOpen(false),
    onSuccess: phone => {
      setPhoneNumber(phone);
      setCallRequested(true);
      setCallRequestModalOpen(false);
    }
  })), displayBanner && /*#__PURE__*/react.createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/react.createElement("a", {
    href: clientRoutes/* default */.A.marketplaceBanner({
      remarketingSettingsId: settings.id,
      source: 'ticket-detail'
    }),
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/react.createElement("img", {
    src: settings.banner_image_url,
    alt: "banner"
  }))));
}
/* harmony default export */ const TicketDetail_Remarketing = (Remarketing);
// EXTERNAL MODULE: ./react/parcelshops/components/BranchInfo.tsx + 2 modules
var BranchInfo = __webpack_require__(57153);
// EXTERNAL MODULE: ./react/components/DropOffCode.tsx
var DropOffCode = __webpack_require__(16787);
;// ./react/client/TicketDetail/Shipping/ShippingDetail.tsx






function IconText(_ref) {
  let {
    iconName,
    text
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-shrink-0"
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: iconName,
    fitted: true,
    color: "gray",
    colorIntensity: 600,
    solid: true
  })), /*#__PURE__*/react.createElement("span", {
    className: "text-sm text-gray-600"
  }, text));
}
function getDayName(date) {
  const today = moment_default()().startOf('day');
  const tomorrow = moment_default()(today).add(1, 'day');
  if (date.isSame(today)) return pgettext('portal_i18n', 'Today');
  if (date.isSame(tomorrow)) return pgettext('portal_i18n', 'Tomorrow');
  return utils/* weekDays */.Mq[date.day() - 1 >= 0 ? date.day() - 1 : 6];
}
function ShippingDetail(_ref2) {
  let {
    shipping
  } = _ref2;
  const getFormattedPickupTime = () => {
    if (!shipping.pickup_interval) {
      return '';
    }
    const [date, start, end] = shipping.pickup_interval.split('_');
    const pickupDate = moment_default()(date);
    const intervalStart = moment_default()(start, 'HH:mm').format('H:mm');
    const intervalEnd = moment_default()(end, 'HH:mm').format('H:mm');
    const day = "".concat(getDayName(pickupDate), " ").concat(pickupDate.format('D. M.'));
    return interpolate(gettext('%(day)s between %(interval_start)s and %(interval_end)s'), {
      day,
      interval_start: intervalStart,
      interval_end: intervalEnd
    }, true);
  };
  const getFormattedShippingAddress = () => {
    if (!shipping.sender_address) {
      return '';
    }
    return "".concat(shipping.sender_address.street, " ").concat(shipping.sender_address.house_number, ",\n          ").concat(shipping.sender_address.city, " ").concat(shipping.sender_address.postal_code);
  };
  return /*#__PURE__*/react.createElement("div", {
    className: "flex flex-wrap items-center justify-between gap-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-4"
  }, shipping.provider_logo_url && /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("img", {
    src: shipping.provider_logo_url,
    alt: "shipping-provider-logo",
    className: "h-10"
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-medium"
  }, (0,utils/* currentLanguage */.aS)(shipping.option_name)), shipping.submit_type !== 'IN_PERSON' && /*#__PURE__*/react.createElement("div", {
    className: "text-xs text-gray-500"
  }, shipping.status_name))), shipping.submit_type === 'PICKUP' && /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/react.createElement(IconText, {
    iconName: "question-mark-circle",
    text: gettext('A courier picks up the package')
  }), /*#__PURE__*/react.createElement(IconText, {
    iconName: "calendar",
    text: getFormattedPickupTime()
  }), /*#__PURE__*/react.createElement(IconText, {
    iconName: "location-marker",
    text: /*#__PURE__*/react.createElement(react.Fragment, null, gettext('From the address'), " ", getFormattedShippingAddress())
  })), shipping.submit_type === 'IN_PERSON' && shipping.customer_parcel_shop && /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/react.createElement(IconText, {
    iconName: "question-mark-circle",
    text: gettext('In-person return to branch')
  }), /*#__PURE__*/react.createElement(BranchInfo/* default */.A, {
    branch: shipping.customer_parcel_shop,
    photoSize: "xl",
    showOpeningHours: true,
    showMapLink: true
  }))), /*#__PURE__*/react.createElement("div", {
    className: "inline-flex flex-wrap gap-4"
  }, shipping.drop_off_code && /*#__PURE__*/react.createElement(DropOffCode/* default */.A, {
    code: shipping.drop_off_code
  }), /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col gap-2"
  }, shipping.labels.map(label => label.file && /*#__PURE__*/react.createElement("a", {
    href: label.file,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/react.createElement(ui/* Button */.$n, null, gettext('Download shipping label'))))), shipping.tracking_url && /*#__PURE__*/react.createElement("a", {
    href: shipping.tracking_url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/react.createElement(ui/* Button */.$n, null, gettext('Package tracking')))));
}
/* harmony default export */ const Shipping_ShippingDetail = (ShippingDetail);
;// ./react/client/TicketDetail/Shipping/index.tsx



const HIDE_STATUSES = ['CANCELED', 'REFUNDED', 'DECLINED', 'FAILURE', 'WAITING'];
function TransportList(_ref) {
  let {
    ticket
  } = _ref;
  if (!ticket.shipping || ticket.shipping.length === 0) return null;
  return /*#__PURE__*/react.createElement(ui/* Card */.Zp, {
    flat: true
  }, /*#__PURE__*/react.createElement(ui/* Card */.Zp.Content, null, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, ticket.shipping.filter(shipping => !HIDE_STATUSES.includes(shipping.status)).map(shipping => /*#__PURE__*/react.createElement(Shipping_ShippingDetail, {
    shipping: shipping
  })))));
}
/* harmony default export */ const Shipping = (TransportList);
// EXTERNAL MODULE: ./react/shipping/utils.ts
var shipping_utils = __webpack_require__(2413);
;// ./react/client/TicketDetail/Transport/TransportDetail.tsx




function TransportDetail(_ref) {
  let {
    transport
  } = _ref;
  const shippingProviderLogo = (0,shipping_utils/* getShippingProviderLogo */.hj)(transport.shipping_provider);
  return /*#__PURE__*/react.createElement("div", {
    className: "flex flex-wrap items-center justify-between gap-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center gap-4"
  }, shippingProviderLogo && /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("img", {
    src: shippingProviderLogo,
    alt: "shipping-provider-logo",
    className: "h-10"
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-medium"
  }, (0,utils/* currentLanguage */.aS)(transport.shipping_type_name)), /*#__PURE__*/react.createElement("div", {
    className: "text-xs text-gray-500"
  }, transport.status_name))), /*#__PURE__*/react.createElement("div", {
    className: "inline-flex flex-wrap gap-4"
  }, transport.file.file && /*#__PURE__*/react.createElement("a", {
    href: transport.file.file,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/react.createElement(ui/* Button */.$n, null, gettext('Download shipping label'))), transport.tracking_url && /*#__PURE__*/react.createElement("a", {
    href: transport.tracking_url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/react.createElement(ui/* Button */.$n, null, gettext('Package tracking')))));
}
/* harmony default export */ const Transport_TransportDetail = (TransportDetail);
;// ./react/client/TicketDetail/Transport/index.tsx



function Transport_TransportList(_ref) {
  let {
    ticket
  } = _ref;
  if (!ticket.transports || ticket.transports.length === 0) return null;
  return /*#__PURE__*/react.createElement(ui/* Card */.Zp, {
    flat: true
  }, /*#__PURE__*/react.createElement(ui/* Card */.Zp.Content, null, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, ticket.transports.filter(transport => transport.status !== 'STATUS_CANCELED').map(transport => /*#__PURE__*/react.createElement(Transport_TransportDetail, {
    transport: transport
  })))));
}
/* harmony default export */ const Transport = (Transport_TransportList);
;// ./react/client/TicketDetail/index.tsx













function TicketDetail() {
  const {
    ticketId
  } = (0,dist/* useParams */.g)();
  const [ticket, setTicket] = (0,react.useState)(null);
  const [ticketNotFound, setTicketNotFound] = (0,react.useState)(false);
  const [steps, setSteps] = (0,react.useState)(null);
  const [products, setProducts] = (0,react.useState)(null);
  const api = (0,public_api/* default */.Ay)();
  const loadTicketOnly = async () => {
    try {
      const data = await api.ClientTicketApi.retrieve({
        id: ticketId
      });
      setTicket(data);
      setSteps(data.process_steps);
    } catch (e) {
      if ((0,public_api_utils/* isResponse */.S)(e) && e.response.status === 404) {
        setTicketNotFound(true);
      }
    }
  };
  const [handleLoadTicketOnly] = (0,hooks/* useAsyncFunction */.m_)(loadTicketOnly);
  const load = async () => {
    await handleLoadTicketOnly();
    const response = await api.ClientTicketProductsApi.list({
      id: ticketId
    });
    setProducts(response);
  };
  const [handleLoad, isLoading] = (0,hooks/* useAsyncFunction */.m_)(load);
  (0,react.useEffect)(() => {
    handleLoad();
  }, []);
  if (ticketNotFound) {
    return /*#__PURE__*/react.createElement(ui/* Card */.Zp, null, /*#__PURE__*/react.createElement(ui/* Card */.Zp.Content, null, /*#__PURE__*/react.createElement("h3", {
      className: "text-center text-2xl font-medium"
    }, gettext('Ticket not found'))));
  }
  return ticket !== null && products !== null && steps !== null && !isLoading ? /*#__PURE__*/react.createElement("div", {
    className: "space-y-8"
  }, /*#__PURE__*/react.createElement(TicketDetail_Header, {
    ticket: ticket,
    steps: steps
  }), /*#__PURE__*/react.createElement(TicketDetail_Products, {
    ticket: ticket,
    products: products
  }), /*#__PURE__*/react.createElement(Transport, {
    ticket: ticket
  }), /*#__PURE__*/react.createElement(Shipping, {
    ticket: ticket
  }), /*#__PURE__*/react.createElement(TicketDetail_Remarketing, {
    ticket: ticket
  }), /*#__PURE__*/react.createElement(TicketDetail_Communication, {
    ticket: ticket,
    onSend: loadTicketOnly
  })) : /*#__PURE__*/react.createElement(ui/* Overlay */.hJ, {
    inverted: true,
    open: true,
    onOverlayClick: () => null
  }, /*#__PURE__*/react.createElement("div", {
    className: "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform"
  }, /*#__PURE__*/react.createElement(ui/* Loader */.aH, {
    size: "huge"
  })));
}
/* harmony default export */ const client_TicketDetail = ((0,mobxreact_esm/* observer */.PA)(TicketDetail));
;// ./react/client/TicketRate.tsx
/* provided dependency */ var TicketRate_moment = __webpack_require__(95093);
function TicketRate_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TicketRate_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TicketRate_ownKeys(Object(t), !0).forEach(function (r) { TicketRate_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TicketRate_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function TicketRate_defineProperty(obj, key, value) { key = TicketRate_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function TicketRate_toPropertyKey(t) { var i = TicketRate_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function TicketRate_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }










function TicketRate() {
  var _ticketRating$permiss;
  const api = (0,public_api/* default */.Ay)();
  const {
    ratingCommentId
  } = (0,dist/* useParams */.g)();
  const {
    company
  } = usePublicCompany();
  const [error, setError] = (0,react.useState)(null);
  const [success, setSuccess] = (0,react.useState)(false);
  const [ticketRating, setTicketRating] = (0,react.useState)(null);
  const send = async () => {
    try {
      const data = await api.ClientRatingCommentApi.patch({
        id: ratingCommentId,
        request: {
          rating: ticketRating === null || ticketRating === void 0 ? void 0 : ticketRating.rating,
          rating_comment: ticketRating === null || ticketRating === void 0 ? void 0 : ticketRating.rating_comment,
          permission_to_publish: ticketRating === null || ticketRating === void 0 ? void 0 : ticketRating.permission_to_publish
        }
      });
      setTicketRating(data);
      setSuccess(true);
    } catch (error) {
      if ((0,public_api_utils/* isResponse */.S)(error)) {
        const responseText = await (0,public_api_utils/* getErrors */.Y)(error);
        setError(responseText);
      }
    }
  };
  const load = async () => {
    try {
      const data = await api.ClientRatingCommentApi.retrieve({
        id: ratingCommentId
      });
      setTicketRating(data);
      if (data.rating_comment_response || data.rating_comment) {
        setSuccess(true);
      }
    } catch (error) {
      if ((0,public_api_utils/* isResponse */.S)(error)) {
        const responseText = await (0,public_api_utils/* getErrors */.Y)(error);
        setError(responseText);
      }
    }
  };
  const [handleSend, isSending] = (0,hooks/* useAsyncFunction */.m_)(send);
  const [handleLoad, isLoading] = (0,hooks/* useAsyncFunction */.m_)(load);
  (0,react.useEffect)(() => {
    handleLoad();
  }, []);
  if (company === null) {
    return null;
  }
  if (isLoading || !ticketRating) {
    return /*#__PURE__*/react.createElement(ui/* Segment */.Y4, {
      padded: true
    }, /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-center"
    }, /*#__PURE__*/react.createElement("div", {
      className: "text-center"
    }, /*#__PURE__*/react.createElement(ui/* Loader */.aH, null))));
  }
  const ratingOptions = [{
    text: gettext('Perfect'),
    value: 2
  }, {
    text: gettext('Good, but...'),
    value: 1
  }, {
    text: gettext('Bad'),
    value: 0
  }];
  return success ? /*#__PURE__*/react.createElement(ui/* Segment */.Y4, {
    padded: true
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/react.createElement("h3", {
    className: "text-2xl font-medium"
  }, gettext('Thank you for your rating!')), /*#__PURE__*/react.createElement("p", null, gettext('We will improve our services based on your feedback.')), /*#__PURE__*/react.createElement("div", {
    className: "pt-2"
  }, /*#__PURE__*/react.createElement(ui/* Card */.Zp, {
    flat: true
  }, /*#__PURE__*/react.createElement("div", {
    className: "p-5"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-baseline justify-between"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center mb-2"
  }, /*#__PURE__*/react.createElement("strong", {
    className: "pr-2"
  }, gettext('Your rating')), /*#__PURE__*/react.createElement(RatingEmoji/* default */.A, {
    rating: ticketRating === null || ticketRating === void 0 ? void 0 : ticketRating.rating,
    size: "small"
  })), /*#__PURE__*/react.createElement("p", {
    className: "text-gray-600"
  }, TicketRate_moment(ticketRating === null || ticketRating === void 0 ? void 0 : ticketRating.created_at).format('LL'))), /*#__PURE__*/react.createElement("p", null, ticketRating === null || ticketRating === void 0 ? void 0 : ticketRating.rating_comment), (ticketRating === null || ticketRating === void 0 ? void 0 : ticketRating.rating_comment_response) && /*#__PURE__*/react.createElement("div", {
    className: "mt-4 p-4 bg-gray-100 border border-gray-300 rounded-lg shadow"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center mb-2"
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: "reply",
    className: "text-gray-700 w-5 h-5 mr-2"
  }), /*#__PURE__*/react.createElement("p", {
    className: "font-semibold text-gray-800"
  }, (0,utils/* currentLanguage */.aS)(company.name))), /*#__PURE__*/react.createElement("p", {
    className: "text-gray-800"
  }, ticketRating === null || ticketRating === void 0 ? void 0 : ticketRating.rating_comment_response))))))) : /*#__PURE__*/react.createElement(ui/* Segment */.Y4, {
    padded: true
  }, /*#__PURE__*/react.createElement("h3", {
    className: "text-center text-2xl font-medium"
  }, gettext('Thank you for your rating!')), /*#__PURE__*/react.createElement("div", {
    className: "flex items-start justify-center gap-8 py-8"
  }, ratingOptions.map(option => /*#__PURE__*/react.createElement("div", {
    style: {
      opacity: ticketRating.rating === option.value ? 1 : 0.2
    },
    key: option.value
  }, /*#__PURE__*/react.createElement("button", {
    onClick: () => setTicketRating(prev => TicketRate_objectSpread(TicketRate_objectSpread({}, prev), {}, {
      rating: option.value
    })),
    type: "button",
    "aria-label": "Set rating to ".concat(option.text)
  }, /*#__PURE__*/react.createElement(RatingEmoji/* default */.A, {
    rating: option.value,
    size: "massive"
  })), /*#__PURE__*/react.createElement("div", {
    className: "pt-3 text-center"
  }, option.text)))), /*#__PURE__*/react.createElement(ui/* Form */.lV, null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Fields, null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Textarea, {
    label: gettext('Help us improve. Tell us what you liked or disliked'),
    onChange: value => setTicketRating(prev => TicketRate_objectSpread(TicketRate_objectSpread({}, prev), {}, {
      rating_comment: value
    })),
    value: ticketRating === null || ticketRating === void 0 ? void 0 : ticketRating.rating_comment
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Checkbox, {
    label: gettext('I agree to make this review publicly available.'),
    onChange: value => setTicketRating(prev => TicketRate_objectSpread(TicketRate_objectSpread({}, prev), {}, {
      permission_to_publish: value
    })),
    value: (_ticketRating$permiss = ticketRating.permission_to_publish) !== null && _ticketRating$permiss !== void 0 ? _ticketRating$permiss : true
  }), /*#__PURE__*/react.createElement("div", {
    className: "flex justify-end"
  }, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    primary: true,
    loading: isSending,
    onClick: handleSend
  }, gettext('Send ticket rating'))), error && /*#__PURE__*/react.createElement(ui/* Segment */.Y4, {
    color: "red"
  }, error))));
}
/* harmony default export */ const client_TicketRate = ((0,mobxreact_esm/* observer */.PA)(TicketRate));
;// ./react/client/TicketUnsubscribe.tsx






function TicketUnsubscribe() {
  const {
    ticketId,
    hashcode
  } = (0,dist/* useParams */.g)();
  const [success, setSuccess] = (0,react.useState)(false);
  const [error, setError] = (0,react.useState)(null);
  const api = (0,public_api/* default */.Ay)();
  const send = async () => {
    try {
      await api.ClientTicketUnsubscribeApi.create({
        id: ticketId,
        hashcode: hashcode
      });
      setSuccess(true);
    } catch (error) {
      if ((0,public_api_utils/* isResponse */.S)(error)) {
        setError(await error.response.text());
      }
    }
  };
  const [handleSend, isSending] = (0,hooks/* useAsyncFunction */.m_)(send);
  return success ? /*#__PURE__*/react.createElement(ui/* Segment */.Y4, {
    padded: true
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/react.createElement("h3", {
    className: "text-2xl font-medium"
  }, gettext('Your address has been unsubscribed')), /*#__PURE__*/react.createElement("p", null, gettext('We will not send you any further messages.')))) : /*#__PURE__*/react.createElement(ui/* Segment */.Y4, null, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/react.createElement("h3", {
    className: "text-2xl font-medium"
  }, gettext('Unsubscribe')), /*#__PURE__*/react.createElement("p", null, gettext('Click the button below to unsubscribe from further emails.')), /*#__PURE__*/react.createElement("p", null, gettext('Please keep in mind that the shop will not be able to inform you about further developments of your ticket. This can make processing your ticket longer.')), error ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ui/* Segment */.Y4, null, error), /*#__PURE__*/react.createElement(ui/* Segment */.Y4, null, gettext('We were not able to unsubscribe you from your ticket automatically. Please contact our support.'), /*#__PURE__*/react.createElement("br", null), /*#__PURE__*/react.createElement(ui/* Button */.$n, null, /*#__PURE__*/react.createElement("a", {
    href: "mailto:support@retino.com"
  }, "support@retino.com")))) : /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    loading: isSending,
    onClick: handleSend
  }, gettext('I understand the risks. Unsubscribe.'))));
}
/* harmony default export */ const client_TicketUnsubscribe = (TicketUnsubscribe);
;// ./react/client/TrackNTrace.tsx




function TrackNTrace() {
  const {
    lang,
    companyId,
    pageId
  } = (0,dist/* useParams */.g)();
  const trackNTraceCode = useTrackNTraceCode(pageId, lang);
  return /*#__PURE__*/react.createElement(components_DangerousHTMLContainer, {
    html: trackNTraceCode
  });
}
/* harmony default export */ const client_TrackNTrace = (TrackNTrace);
// EXTERNAL MODULE: ./react/components/errorBoundaries/index.tsx
var errorBoundaries = __webpack_require__(83819);
// EXTERNAL MODULE: ./react/components/ScrollToTop.tsx
var ScrollToTop = __webpack_require__(53199);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(46942);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// ./react/components/RetinoLoader.tsx



function RetinoLoader(_ref) {
  let {
    gray,
    transparent
  } = _ref;
  const color = gray ? 'text-gray-600' : 'text-brand-700';
  return /*#__PURE__*/react.createElement(ui/* Overlay */.hJ, {
    inverted: true,
    transparent: transparent,
    open: true,
    onOverlayClick: () => null
  }, /*#__PURE__*/react.createElement("div", {
    className: "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col items-center"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-shrink-0 items-center justify-center px-6 ".concat(color)
  }, /*#__PURE__*/react.createElement("div", {
    className: "w-48"
  }, /*#__PURE__*/react.createElement(LogoIcon/* default */.A, null))), /*#__PURE__*/react.createElement("div", {
    className: "mt-8"
  }, /*#__PURE__*/react.createElement(ui/* Loader */.aH, {
    size: "huge"
  })))));
}
/* harmony default export */ const components_RetinoLoader = (RetinoLoader);
;// ./react/layouts/ClientLayout.tsx








function ClientLayout(_ref) {
  let {
    hideFooter = false,
    gray = true
  } = _ref;
  const {
    company
  } = usePublicCompany();
  if (company === null) {
    return /*#__PURE__*/react.createElement(components_RetinoLoader, null);
  }
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()('w-full', gray ? 'bg-gray-50' : 'bg-white')
  }, /*#__PURE__*/react.createElement("div", {
    className: "mx-auto min-h-screen max-w-screen-lg space-y-6 py-4 px-0 sm:p-4 md:p-6"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-wrap justify-between gap-2"
  }, /*#__PURE__*/react.createElement("div", null, company.logo_url ? /*#__PURE__*/react.createElement("img", {
    src: (0,utils/* currentLanguage */.aS)(company.logo_url),
    alt: (0,utils/* currentLanguage */.aS)(company.name),
    className: "h-20"
  }) : /*#__PURE__*/react.createElement("span", {
    className: "text-2xl font-medium text-gray-700"
  }, (0,utils/* currentLanguage */.aS)(company.name))), company.shop_url && /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    icon: "external-link",
    size: "tiny"
  }, /*#__PURE__*/react.createElement("a", {
    href: (0,utils/* currentLanguage */.aS)(company.shop_url)
  }, interpolate(gettext('Go to %(company_name)s'), {
    company_name: (0,utils/* currentLanguage */.aS)(company.name)
  }, true))))), /*#__PURE__*/react.createElement("div", {
    className: "mt-8"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(dist/* Outlet */.sv, null)), !hideFooter && /*#__PURE__*/react.createElement("footer", {
    className: "footer footer-transparent mt-12 space-y-6 pb-12"
  }, /*#__PURE__*/react.createElement("div", {
    className: "company-logo"
  }, company.logo_url ? /*#__PURE__*/react.createElement("img", {
    src: (0,utils/* currentLanguage */.aS)(company.logo_url),
    alt: (0,utils/* currentLanguage */.aS)(company.name),
    className: "mx-auto w-32"
  }) : /*#__PURE__*/react.createElement("div", {
    className: "text-center font-medium text-gray-600"
  }, (0,utils/* currentLanguage */.aS)(company.name))), /*#__PURE__*/react.createElement("div", {
    className: "mx-auto text-center text-sm text-gray-400"
  }, /*#__PURE__*/react.createElement("a", {
    href: "https://www.retino.com/",
    target: "blank",
    rel: "noopener noreferrer"
  }, gettext("We're using"), /*#__PURE__*/react.createElement("div", {
    className: "mx-auto w-20 pt-2 text-gray-400"
  }, /*#__PURE__*/react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1980 455"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M196 223c40 0 63-19 63-50v-1c0-33-24-50-64-50h-77v102h78M0 18h202c65 0 110 17 139 46 25 24 37 57 37 99v1c0 65-34 108-87 131l101 148H256l-86-129h-51v129H0V18zm617 235c-4-36-25-59-57-59-30 0-51 23-57 59h114m-224 28v-1c0-96 69-172 166-172 114 0 166 83 166 180 0 7 0 15-1 24H504c9 36 35 54 71 54 27 0 49-10 73-33l64 53c-31 40-77 67-143 67-103 0-177-69-177-171zm392 61V208h-39v-93h39V31h116v83h76v93h-76v111c0 23 10 32 31 32 15 0 29-4 43-10v90c-20 11-48 18-80 18-69 0-111-30-111-109zm237-227h116v330h-116V115M1021 0h120v85h-120V0zm471 242c2.06.01 11.79.04 26.21.09v-12c0-75-42-121-112-121-47 0-77 26-98 53v-46h-116v330h116V266c0-36 20-55 48-55 27 0 46 19 46 55v178h116V305l-55-63 29.03.04zm253-136c-92 0-182 64-194 152 38.51.15 91.31-.13 125 0 54-1-172-2-183-2 40 45 79 91 119 136 39-45 79-90 119-135h-54c7-41 39-50 68-50 41 0 71 34 71 75 0 41-27 75-69 75-24 0-45-12-57-30l-64 74c32 29 68 55 120 55 107 0 185-79 185-174 0-96-77-174-184-174z"
  })))))))));
}
/* harmony default export */ const layouts_ClientLayout = ((0,mobxreact_esm/* observer */.PA)(ClientLayout));
// EXTERNAL MODULE: ./react/ui/toast/ToastStore.ts
var ToastStore = __webpack_require__(2102);
;// ./react/client_index.tsx





















const Retino = (0,mobxreact_esm/* observer */.PA)(() => {
  const [toastStore] = (0,react.useState)(new ToastStore/* default */.Ay());
  (0,react.useEffect)(() => {
    window.appState.toastStore = toastStore;
  }, []);
  return /*#__PURE__*/react.createElement(ToastStore/* ToastStoreContext */.yG.Provider, {
    value: toastStore
  }, /*#__PURE__*/react.createElement(ScrollToTop/* default */.A, null), /*#__PURE__*/react.createElement(PublicCompanyProvider, null, /*#__PURE__*/react.createElement(dist/* Routes */.BV, null, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    element: /*#__PURE__*/react.createElement(layouts_ClientLayout, null)
  }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: clientRoutes/* default */.A.ticketTicketIdUnsubscribeHashcode.url,
    element: /*#__PURE__*/react.createElement(client_TicketUnsubscribe, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: clientRoutes/* default */.A.ticketTicketIdRatingRatingCommentDetail.url,
    element: /*#__PURE__*/react.createElement(client_TicketRate, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: clientRoutes/* default */.A.ticketTicketDetail.url,
    element: /*#__PURE__*/react.createElement(client_TicketDetail, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: clientRoutes/* default */.A.transportShippingIdRatingRating.url,
    element: /*#__PURE__*/react.createElement(client_CustomerPaidShippingRating, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: clientRoutes/* default */.A.shippingShippingIdRatingRating.url,
    element: /*#__PURE__*/react.createElement(client_ShippingRating, null)
  })), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: "/:lang/client/:companyId/badge/report/",
    element: /*#__PURE__*/react.createElement(badge_BadgeReport, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    element: /*#__PURE__*/react.createElement(layouts_ClientLayout, {
      hideFooter: true
    })
  }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: clientRoutes/* default */.A.portal.url,
    element: /*#__PURE__*/react.createElement(portal_ClientPortal, null)
  }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: clientRoutes/* default */.A.shippingPortal.url,
    element: /*#__PURE__*/react.createElement(ClientShippingPortal, null)
  })), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    element: /*#__PURE__*/react.createElement(layouts_ClientLayout, {
      hideFooter: true,
      gray: false
    })
  }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
    path: clientRoutes/* default */.A.trackAndTracePageDetail.url,
    element: /*#__PURE__*/react.createElement(client_TrackNTrace, null)
  })))), /*#__PURE__*/react.createElement(ui/* ToastContainer */.N9, null));
});
const container = document.getElementById('react-root');
const root = (0,client/* createRoot */.H)(container);
root.render( /*#__PURE__*/react.createElement(react_router_dom_dist/* BrowserRouter */.Kd, null, /*#__PURE__*/react.createElement(errorBoundaries/* ErrorBoundary */.t, null, /*#__PURE__*/react.createElement(public_api/* PublicApiProvider */.Fm, null, /*#__PURE__*/react.createElement(Retino, null)))));
;// ./assets/client_bundle.jsx
/* provided dependency */ var client_bundle_moment = __webpack_require__(95093);
/*
 *   This will build into .js and .css files that can be rendered:
 *
 *   include:    {% load render_bundle from webpack_loader %}
 *   head:       {% render_bundle 'client_bundle' 'css' %}
 *   footer:     {% render_bundle 'client_bundle' 'js' %}
 */











/* react app */


(0,mobx_esm/* configure */.jK)({
  enforceActions: 'never',
});

if (true) {
  sdk/* init */.T({
    dsn: 'https://b66899ef04f24590954284699e871c64@sentry.io/1223003',
    environment: "production",
    release: 'could-not-get-sha',
    denyUrls: blacklisted_urls/* default */.A,
    ignoreErrors: blacklisted_errors/* default */.A,
  });

  const scope = esm_exports/* getCurrentScope */.o5();
  scope.setTag('bundle', 'Client');
  scope.setExtra('appState', window.appState);

  window.Sentry = esm;
} else {}

client_bundle_moment.locale(window.appState.lang);


/***/ }),

/***/ 41906:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $g: () => (/* binding */ formatPrice),
/* harmony export */   HA: () => (/* binding */ nl2br),
/* harmony export */   Mq: () => (/* binding */ weekDays),
/* harmony export */   Rg: () => (/* binding */ isFrontendOutdated),
/* harmony export */   aS: () => (/* binding */ currentLanguage),
/* harmony export */   g6: () => (/* binding */ toggleItem),
/* harmony export */   hW: () => (/* binding */ nl2p),
/* harmony export */   q2: () => (/* binding */ convertHeicToJpeg),
/* harmony export */   qr: () => (/* binding */ useContextSafe),
/* harmony export */   wu: () => (/* binding */ isImage),
/* harmony export */   yl: () => (/* binding */ conatinsHTMLTags)
/* harmony export */ });
/* unused harmony exports rgetattr, assert, currencyDisplay, useI18nToStr, arrayMove, changeCollection, convertDecimal, usePrevValue, isProductionEnvironment, useRerender, getForegroundColor, isUUID, roundHalfUp, indexArrayByProp, useAsyncEffect, formatDateAsMomentCalendar, monthNames, getNextNDays, compareObjects, compareQueries, makeAbsoluteUrl, isUrlValid, excerpt, formatNumber, formatLongDate, getOrderPortalDirectLink, useStoreUrlConnect, parseUrlSearch, parsedUrlSearchArrayValuesToSingleValues, toUrlSearchString, loadScript, LocalStorageCache */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var contexts_CurrentLanguageContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60758);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2543);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var stores_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9432);
/* harmony import */ var stores_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25193);
/* provided dependency */ var moment = __webpack_require__(95093);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








/**
 * Get nested attribute from object
 * rgetattr(obj, 'test.attr1') == obj.test.attr1
 * @param {object} obj
 * @param {string} attrName
 * @param {string} separator
 */
const rgetattr = function (obj, attrName) {
  let separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  const attrList = attrName.split(separator);
  let value = obj && obj[attrList[0]];
  for (let i = 1; i < attrList.length; ++i) value = value && value[attrList[i]];
  return value;
};
function assert(condition) {
  let msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Assertion Error';
  if (!condition) {
    throw new Error(msg);
  }
}
const currencyDisplay = currencyISO => stores_constants__WEBPACK_IMPORTED_MODULE_4__/* .allCurrenciesSymbol */ .pH[currencyISO] || currencyISO;
const currentLanguage = (i18nObject, lang) => {
  if (i18nObject === null || i18nObject === undefined) return '';
  if (typeof i18nObject === 'string') {
    return i18nObject;
  }

  // Helper function to get value with fallback to base language
  const getLangWithFallback = langCode => {
    const value = i18nObject[langCode];
    if (value) return value;

    // Try base language if regional variant (e.g., 'de-at' -> 'de')
    if (langCode.includes('-')) {
      const baseLang = langCode.split('-')[0];
      return i18nObject[baseLang];
    }
    return undefined;
  };

  // Try provided lang parameter first
  if (lang) {
    const value = getLangWithFallback(lang);
    if (value) return value;
  }

  // Try window.appState.lang
  const appLang = window.appState.lang;
  const appValue = getLangWithFallback(appLang);
  if (appValue) return appValue;

  // Finally, fallback to first truthy value
  return Object.values(i18nObject).find(a => !!a) || '';
};
const useI18nToStr = () => {
  const lang = useCurrentLanguage();
  return i18nObject => currentLanguage(i18nObject, lang) || '';
};
const arrayMove = (items, oldIndex, newIndex) => {
  const copiedItems = [...items]; // shallow copy
  const [tmp] = copiedItems.splice(oldIndex, 1);
  copiedItems.splice(newIndex, 0, tmp);
  return copiedItems;
};
function changeCollection(col1, col2, oldIndex, newIndex) {
  const copyCol1 = [...col1]; // shallow copy
  const copyCol2 = [...col2]; // shallow copy
  const [tmp] = copyCol1.splice(oldIndex, 1); // remove from old collection
  copyCol2.splice(newIndex, 0, tmp); // insert to new
  return [copyCol1, copyCol2];
}
const convertDecimal = (price, currency) => Number(price) / 100;
const formatPrice = function (price, currency) {
  let isDecimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (isDecimal) price = convertDecimal(price, currency);
  try {
    const fractionDigits = price % 1 === 0 ? 0 : undefined;
    const langCode = window.appState.lang;
    const priceFormatter = Intl.NumberFormat(langCode, {
      style: 'currency',
      currency,
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits
    });
    return priceFormatter.format(price);
  } catch (error) {
    console.error(error);
    return "".concat(price, " ").concat(currency);
  }
};
function nl2br(str) {
  str = str || '';
  const newlineRegex = /(\r\n|\r|\n)/g;
  if (typeof str === 'number') {
    return str;
  }
  if (typeof str !== 'string') {
    return '';
  }
  return str.split(newlineRegex).map((line, index) => {
    if (line.match(newlineRegex)) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement('br', {
        key: index
      });
    }
    return line;
  });
}
function nl2p(str) {
  return str.split('\n').map(item => "<p>".concat(item, "</p>")).join('');
}
const usePrevValue = props => {
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    ref.current = props;
  });
  return ref.current;
};
const isProductionEnvironment = () => "production" === 'production';
const useRerender = () => {
  const [, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const rerender = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => setValue(v => !v), []);
  return rerender;
};
const getForegroundColor = backgroundColor => {
  /* This will be black or white - the one that will be more suitable for selected background color */
  const darkColor = '#000000';
  const lightColor = '#ffffff';

  // creates array ["RR", "GG", "BB"]
  const parsedColor = backgroundColor.slice(1).match(/.{2}/g);
  if (parsedColor === null || parsedColor.length !== 3) return darkColor;

  // applies this magic formula 'if (red*0.299 + green*0.587 + blue*0.114) > 186 use #000000 else use #ffffff'
  const backgroundColorIntensivness = parsedColor.map(x => parseInt(x, 16)).reduce((acc, curr, i) => acc + curr * [0.299, 0.587, 0.114][i], 0);
  return backgroundColorIntensivness > 150 ? darkColor : lightColor;
};
const isUUID = str => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(str);
const roundHalfUp = (value, decimals) => {
  const decimal = Math.round(Number("".concat(value, "e").concat(decimals)));
  return Number("".concat(decimal, "e-").concat(decimals));
};
function useContextSafe(context) {
  const value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(context);
  if (value === null || value === undefined) {
    throw Error("Context ".concat(context, " must be used within context provider!"));
  }
  return value;
}
const indexArrayByProp = (array, prop) => array.reduce((acc, curr) => {
  acc[curr[prop]] = curr;
  return acc;
}, {});
const useAsyncEffect = (func, deps) => (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
  func();
}, deps);
const formatDateAsMomentCalendar = date => moment(date).calendar(null, {
  sameDay: "[".concat(gettext('Today'), "]"),
  nextDay: "[".concat(gettext('Tomorrow'), "]"),
  nextWeek: 'LL',
  lastDay: "[".concat(gettext('Yesterday'), "]"),
  lastWeek: 'LL',
  sameElse: 'LL'
});
const weekDays = [gettext('Monday'), gettext('Tuesday'), gettext('Wednesday'), gettext('Thursday'), gettext('Friday'), gettext('Saturday'), gettext('Sunday')];
const monthNames = [gettext('January'), gettext('February'), gettext('March'), gettext('April'), gettext('May'), gettext('June'), gettext('July'), gettext('August'), gettext('September'), gettext('October'), gettext('November'), gettext('December')];
const getNextNDays = count => {
  const today = new Date();
  const addDays = days => {
    const d = new Date(today.valueOf());
    d.setDate(d.getDate() + days);
    return d;
  };
  const getDayIndex = offset => (offset + today.getDay()) % 7;
  const getDayName = offset => "".concat(getDayIndex(offset) === today.getDay() ? gettext('Tomorrow') : weekDays[getDayIndex(offset)], ", ").concat(moment(addDays(offset + 1)).format('D. M.'));
  return [...Array(count).keys()].map(i => [getDayIndex(i), getDayName(i)]);
};
function compareObjects(q1, q2) {
  let excludeFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return isEqual(omit(q1, excludeFields), omit(q2, excludeFields));
}
function compareQueries(q1, q2) {
  let excludeFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return compareObjects(q1, q2, [...excludeFields, 'page', 'search']);
}
function toggleItem(list, updatedElement) {
  if (!list) {
    return [updatedElement];
  }
  return list.includes(updatedElement) ? list.filter(item => item !== updatedElement) : [...list, updatedElement];
}
function makeAbsoluteUrl(url) {
  if (url) {
    const defaultProtocol = 'https';
    if (!url.match(/^(https?:)?\/\//)) {
      return "".concat(defaultProtocol, "://").concat(url);
    }
  }
  return url;
}
function isUrlValid(url) {
  const urlRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/gm;
  return urlRegex.test(url);
}
function isImage(filename) {
  if (filename === undefined || filename === null) return false;
  return filename.match(/(.*\.jpeg|.*\.jpg|.*\.png|.*\.gif|.*\.svg)/);
}
const excerpt = (s, len) => s.length > len ? "".concat(s.substr(0, len - 3), "...") : s;
const formatNumber = n => new Intl.NumberFormat(window.appState.lang).format(n);
const formatLongDate = isoDate => {
  const date = new Date(isoDate);
  return date.toLocaleDateString(window.appState.lang, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};
function getOrderPortalDirectLink(companyId, email, orderCode, lang) {
  return "".concat(window.location.origin, "/").concat(lang, "/order-tracking/").concat(companyId, "/direct-link/?email=").concat(email, "&code=").concat(orderCode);
}
function useStoreUrlConnect(store) {
  const isMounted = useRef(true);
  const history = useHistory();
  const [, setSearchParams] = useSearchParams();
  const loadUrlQuery = () => store.loadFromURLQuery(history.location.search);
  const setUrlQuery = () => {
    if (!isMounted.current || !store.isLoaded) return;
    setSearchParams(store.urlQuery);
  };
  const load = async () => {
    if (!isMounted.current) return;
    await loadUrlQuery();
    setUrlQuery();
  };
  useEffect(() => {
    load();
    const disposer = autorun(() => {
      setUrlQuery();
    });
    isMounted.current = true;
    return () => {
      disposer();
      isMounted.current = false;
    };
  }, []);
}
function parseUrlSearch(search) {
  if (!search) {
    return {};
  }

  // Parse url search string into object. Each key has an array of values (even single values are in array).
  const searchParams = new URLSearchParams(search);
  const result = {};
  searchParams.forEach((value, key) => {
    if (!(key in result)) {
      result[key] = [];
    }
    try {
      result[key].push(JSON.parse(value));
    } catch (e) {
      result[key].push(value);
    }
  });
  return result;
}
function parsedUrlSearchArrayValuesToSingleValues(parsedUrlSearch) {
  // e.g. {'is_valid': [true], 'another_key': [7], 'key': [2, 6, 7]} -> {'is_valid': true, 'another_key': 7, 'key': [2, 6, 7]}
  return Object.entries(parsedUrlSearch).reduce((acc, _ref) => {
    let [key, value] = _ref;
    return Array.isArray(value) && value.length === 1 ? _objectSpread(_objectSpread({}, acc), {}, {
      [key]: value[0]
    }) : _objectSpread(_objectSpread({}, acc), {}, {
      [key]: value
    });
  }, {});
}
function toUrlSearchString(queryObj) {
  if (!queryObj || Object.keys(queryObj).length === 0) {
    return '';
  }
  const searchParams = new URLSearchParams();
  Object.entries(queryObj).forEach(_ref2 => {
    let [key, value] = _ref2;
    return value !== undefined && (Array.isArray(value) ? value.forEach(val => searchParams.append(key, val)) : searchParams.append(key, value));
  });
  return searchParams.toString();
}
function isFrontendOutdated() {
  return window.appState.bundleHash !== window.appState.latestBundleHash;
}
function conatinsHTMLTags(str) {
  const doc = new DOMParser().parseFromString(str, 'text/html');
  return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
}
const convertHeicToJpeg = async file => {
  /**
   * Converts a HEIC image file to a JPEG format.
   *
   * @param {File} file - The HEIC file to be converted.
   *
   * @returns {Promise<File>} - A Promise that resolves to the converted JPEG file.
   *
   * @description
   * This function takes a HEIC file as input, uses a web worker and an external library (libheif)
   * to process and convert the HEIC file to JPEG format. The conversion is done asynchronously,
   * and the resulting JPEG file is returned in a Promise. The function also handles error reporting
   * through Sentry in case of conversion or worker errors.
   *
   * - It creates a temporary URL for the input file.
   * - It communicates with a web worker responsible for performing the conversion using the HEIF library.
   * - The converted file's name is derived from the original HEIC file but with a ".jpeg" extension.
   * - Any errors during conversion are captured by Sentry and propagated to the caller via rejection.
   * - The temporary URL is revoked after the conversion is complete.
   */

  const workerScriptUrl = "".concat(window.appState.baseStaticUrl, "heicToJpgConvertor.js");
  const libHeifUrl = "".concat(window.appState.baseStaticUrl, "libheif-bundle.js");
  const workerScriptContent = await (await fetch(workerScriptUrl)).blob();
  const url = URL.createObjectURL(workerScriptContent);

  // this needs to be a data/blob URL because Workers need to be served from the same origin as the main thread
  // therefore we cannot load the worker script from a different origin (e.g. cdn)
  // See https://developer.mozilla.org/en-US/docs/Web/API/Worker/Worker#security_considerations
  // and https://stackoverflow.com/questions/21913673/execute-web-worker-from-different-origin
  const worker = new Worker(url);
  const convertedFile = await new Promise((resolve, reject) => {
    const imageBlob = new Blob([file], {
      type: 'image/heic'
    });
    worker.postMessage({
      file: imageBlob,
      libHeifUrl
    });
    worker.onmessage = e => {
      if (e.data.error) {
        window.Sentry.captureException(new Error(e.data.error));
        reject(new Error(e.data.error));
      } else if (e.data.blob) {
        const name = file.name.replace(/\.heic$/i, '.jpeg');
        resolve(new File([e.data.blob], name, {
          type: 'image/jpeg'
        }));
      }
    };
    worker.onerror = err => {
      window.Sentry.captureException(err);
      reject(err);
    };
  });
  worker.terminate();
  URL.revokeObjectURL(url);
  return convertedFile;
};
const loadScript = (() => {
  // Cache for storing ongoing load promises
  const scriptPromises = {};
  return (src, id) => {
    // If a script load has already been initiated, return the same promise
    if (scriptPromises[id]) {
      return scriptPromises[id];
    }
    scriptPromises[id] = new Promise((resolve, reject) => {
      const scriptElement = document.getElementById(id);
      if (!scriptElement) {
        // Create the script element if it doesn't exist
        const script = document.createElement('script');
        script.src = src;
        script.id = id;
        const handleLoadScriptSuccess = () => {
          script.setAttribute('loaded', 'true'); // Mark as loaded
          resolve({
            successful: true
          });
          delete scriptPromises[id]; // Clean up cache
        };
        const handleLoadScriptFail = event => {
          reject(new Error(event.toString()));
          delete scriptPromises[id]; // Clean up cache
        };
        script.addEventListener('load', handleLoadScriptSuccess, {
          once: true
        });
        script.addEventListener('error', handleLoadScriptFail, {
          once: true
        });
        document.head.appendChild(script);
      } else if (scriptElement.getAttribute('loaded') === 'true') {
        // If the script is already loaded
        resolve({
          successful: true
        });
      } else {
        // Script is not yet loaded, wait for it to finish loading
        scriptElement.addEventListener('load', () => resolve({
          successful: true
        }), {
          once: true
        });
        scriptElement.addEventListener('error', event => reject(new Error(event.toString())), {
          once: true
        });
      }
    });
    return scriptPromises[id];
  };
})();

/**
 * A cache interface for storing and retrieving data with timestamps
 */

/**
 * LocalStorageCache provides a convenient way to cache data in localStorage with
 * automatic expiration handling.
 */
class LocalStorageCache {
  /**
   * Create a new LocalStorageCache instance
   *
   * @param key - The specific key for this cache instance
   * @param prefix - The prefix for the localStorage key
   * @param timeoutSec - Timeout in seconds (default: 7 days)
   */
  constructor(key) {
    let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'LOCAL_STORAGE_CACHE';
    let timeoutSec = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7 * 24 * 60 * 60;
    this.cacheKey = void 0;
    this.prefix = void 0;
    this.key = void 0;
    this.timeoutMs = void 0;
    this.prefix = prefix;
    this.key = key;
    this.timeoutMs = timeoutSec * 1000;
    this.cacheKey = "".concat(this.prefix, "_").concat(this.key);
  }

  /**
   * Store data in the cache
   *
   * @param data - The data to cache
   * @param isRetry - Whether this is a retry attempt after clearing space
   * @returns void
   */
  save(data) {
    let isRetry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const cachedData = {
      timestamp: Date.now(),
      data
    };
    try {
      localStorage.setItem(this.cacheKey, JSON.stringify(cachedData));
    } catch (error) {
      // Check if it's a quota exceeded error using MDN-specified identifiers
      // https://developer.mozilla.org/en-US/docs/Web/API/Storage_API/Storage_quotas_and_eviction_criteria#web_storage
      if (!isRetry && error instanceof DOMException && (
      // Standard
      error.name === 'QuotaExceededError' || error.code === DOMException.QUOTA_EXCEEDED_ERR ||
      // Firefox
      error.name === 'NS_ERROR_DOM_QUOTA_REACHED' ||
      // Safari/WebKit
      error.name === 'QUOTA_EXCEEDED_ERR')) {
        // Clear old caches with the same prefix
        if (this.prefix) {
          this.clearCachesWithPrefix();
        } else {
          this.clear();
        }
        // Try again with isRetry flag to prevent infinite recursion
        this.save(data, true);
      } else if (window.Sentry) {
        // Either it's already a retry attempt or it's a different error
        window.Sentry.captureException(error);
      }
    }
  }

  /**
   * Load data from the cache if it exists and is not expired
   *
   * @returns The cached data or null if no valid cache exists
   */
  load() {
    const cachedDataString = localStorage.getItem(this.cacheKey);
    if (cachedDataString) {
      try {
        const cachedData = JSON.parse(cachedDataString);
        const currentTime = Date.now();

        // Check if cache is still valid (less than timeout)
        if (cachedData.timestamp && currentTime - cachedData.timestamp < this.timeoutMs) {
          return cachedData.data;
        }
      } catch (error) {
        if (window.Sentry) {
          window.Sentry.captureException(error);
        }
      }

      // Cache is expired or invalid, remove it
      localStorage.removeItem(this.cacheKey);
    }
    return null;
  }

  /**
   * Check if there is valid data in the cache
   *
   * @returns boolean indicating if valid cache exists
   */
  hasValidCache() {
    return this.load() !== null;
  }

  /**
   * Remove this cache entry
   */
  clear() {
    localStorage.removeItem(this.cacheKey);
  }

  /**
   * Clear all caches with the given prefix
   *
   * @param prefix - The prefix to match for clearing caches
   */
  clearCachesWithPrefix() {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(this.prefix)) {
        keysToRemove.push(key);
      }
    }

    // Remove the collected keys
    keysToRemove.forEach(key => localStorage.removeItem(key));
  }
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  arrayMove,
  assert,
  conatinsHTMLTags,
  convertHeicToJpeg,
  currencyDisplay,
  currentLanguage,
  excerpt,
  formatDateAsMomentCalendar,
  formatLongDate,
  formatPrice,
  getForegroundColor,
  getOrderPortalDirectLink,
  indexArrayByProp,
  isFrontendOutdated,
  isImage,
  isUrlValid,
  loadScript,
  LocalStorageCache,
  makeAbsoluteUrl,
  monthNames,
  nl2br,
  nl2p,
  parseUrlSearch,
  rgetattr,
  roundHalfUp,
  toUrlSearchString,
  useAsyncEffect,
  usePrevValue,
  useRerender,
  weekDays
});

/***/ }),

/***/ 2413:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QJ: () => (/* binding */ condensateOpenHours),
/* harmony export */   hj: () => (/* binding */ getShippingProviderLogo)
/* harmony export */ });
/* unused harmony exports getShippingProviderName, getShippingStatusName, getShippingTypePrice, getShippingTypesPriceStr */
/* harmony import */ var img_shipping_logo_ppl_jpg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14821);
/* harmony import */ var img_shipping_logo_zasilkovna_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19869);
/* harmony import */ var img_shipping_logo_ppl_dhl_png__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36908);
/* harmony import */ var img_shipping_logo_dhl_png__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46137);
/* harmony import */ var img_shipping_logo_zasilkovna_big_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54518);
/* harmony import */ var img_shipping_logo_gls_jpg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93193);
/* harmony import */ var img_shipping_logo_liftago_png__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65711);
/* harmony import */ var img_shipping_dpd_logo_png__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60291);
/* harmony import */ var img_shipping_logo_geis_png__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34237);
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41906);










const getShippingProviderName = shippingProvider => {
  switch (shippingProvider) {
    case 'RETINO_PPL':
    case 'CUSTOMER_RETINO_PPL':
      return gettext('PPL Parcelshop');
    case 'CUSTOMER_RETINO_GLS_DROPOFF':
    case 'MY_GLS_DROPOFF':
      return gettext('GLS Parcelshop');
    case 'CUSTOMER_RETINO_GLS_PICKUP':
    case 'CUSTOMER_RETINO_GLS_PICKUP_SK':
    case 'CUSTOMER_RETINO_GLS_PICKUP_HU':
      return gettext('GLS pickup');
    case 'ZASILKOVNA':
      return gettext('Zasilkovna');
    case 'GLS':
    case 'MY_GLS':
      return gettext('GLS pickup');
    case 'GLS_DROPOFF_PL':
      return gettext('GLS Parcelshop Poland');
    case 'PPL':
      return gettext('PPL pickup');
    case 'DPD_PICKUP':
    case 'CUSTOMER_PAID_RETINO_DPD_PICKUP':
      return gettext('DPD pickup');
    case 'DPD_DROPOFF':
    case 'CUSTOMER_PAID_RETINO_DPD_DROPOFF':
      return gettext('DPD dropoff');
    case 'LIFTAGO':
      return gettext('Liftago');
    case 'RETURN_CONNECT':
      return gettext('PPL Return Connect');
    case 'CUSTOM_OTHER_PROVIDER':
      return gettext('Custom shipping provider');
    case 'GEIS':
      return gettext('Geis');
    case 'DHL_FREIGHT':
      return gettext('DHL Freight');
    case 'DHL_DROPOFF':
      return gettext('DHL Parcelshop');
    default:
      return null;
  }
};
const getShippingStatusName = status => {
  switch (status) {
    case 'STATUS_INIT':
      return gettext('Allowed');
    case 'STATUS_PENDING_CONFIRMATION':
      return gettext('Pending confirmation');
    case 'STATUS_ACCEPTED':
      return gettext('Generated shipping label');
    case 'STATUS_SUBMITTED':
      return gettext('Delivered to the branch');
    case 'STATUS_TRANSPORT':
      return gettext('Supplied by the carrier');
    case 'STATUS_DELIVERED':
      return gettext('Delivered');
    case 'STATUS_UNDELIVERED':
      return gettext('Undelivered');
    case 'STATUS_CANCELED':
      return gettext('Cancelled');
    case 'STATUS_REFUNDED':
      return gettext('Refunded');
    case 'STATUS_UNKNOWN':
      return gettext('Unknown');
    default:
      return null;
  }
};
const getShippingProviderLogo = function (shippingProvider) {
  let shape = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'square';
  switch (shippingProvider) {
    case 'RETINO_PPL':
    case 'CUSTOMER_RETINO_PPL':
    case 'PPL':
      return img_shipping_logo_ppl_jpg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A;
    case 'ZASILKOVNA':
      return shape === 'rect' ? img_shipping_logo_zasilkovna_big_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A : img_shipping_logo_zasilkovna_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A;
    case 'GLS':
    case 'MY_GLS':
    case 'MY_GLS_DROPOFF':
    case 'GLS_DROPOFF_PL':
    case 'CUSTOMER_RETINO_GLS_PICKUP':
    case 'CUSTOMER_RETINO_GLS_PICKUP_SK':
    case 'CUSTOMER_RETINO_GLS_PICKUP_HU':
    case 'CUSTOMER_RETINO_GLS_DROPOFF':
    case 'CUSTOMER_RETINO_GLS_DROPOFF_SK':
    case 'CUSTOMER_RETINO_GLS_DROPOFF_HU':
      return img_shipping_logo_gls_jpg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A;
    case 'LIFTAGO':
      return img_shipping_logo_liftago_png__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A;
    case 'DPD_DROPOFF':
    case 'DPD_PICKUP':
    case 'CUSTOMER_PAID_RETINO_DPD_DROPOFF':
    case 'CUSTOMER_PAID_RETINO_DPD_PICKUP':
      return img_shipping_dpd_logo_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A;
    case 'RETURN_CONNECT':
      return img_shipping_logo_ppl_dhl_png__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A;
    case 'GEIS':
      return img_shipping_logo_geis_png__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A;
    case 'DHL_DROPOFF':
    case 'DHL_FREIGHT':
      return img_shipping_logo_dhl_png__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A;
    default:
      return null;
  }
};
const getShippingTypePrice = item => item.shipping_provider_data.paid_by_customer && item.shipping_provider_data.customer_price ? item.shipping_provider_data.customer_price : {
  price: Number(item.displayed_price),
  currency: item.displayed_currency
};
const getShippingTypesPriceStr = shippingTypes => {
  const allFree = !shippingTypes.some(item => getShippingTypePrice(item).price);
  if (allFree) {
    return gettext('free');
  }
  const someFree = shippingTypes.some(item => !getShippingTypePrice(item).price);
  const lowestPrice = shippingTypes.reduce((_ref, item) => {
    let {
      price,
      currency
    } = _ref;
    return getShippingTypePrice(item).price < price && getShippingTypePrice(item).price > 0 ? {
      price: getShippingTypePrice(item).price,
      currency: getShippingTypePrice(item).currency
    } : {
      price,
      currency
    };
  }, {
    price: Infinity,
    currency: ''
  });
  if (someFree) {
    return interpolate(gettext('free or from %(price)s'), {
      price: (0,helpers_utils__WEBPACK_IMPORTED_MODULE_0__/* .formatPrice */ .$g)(lowestPrice.price, lowestPrice.currency)
    }, true);
  }
  if (shippingTypes.length === 1) {
    return (0,helpers_utils__WEBPACK_IMPORTED_MODULE_0__/* .formatPrice */ .$g)(lowestPrice.price, lowestPrice.currency);
  }
  return interpolate(gettext('from %(price)s'), {
    price: (0,helpers_utils__WEBPACK_IMPORTED_MODULE_0__/* .formatPrice */ .$g)(lowestPrice.price, lowestPrice.currency)
  }, true);
};
const condensateOpenHours = dropOffBranch => {
  let startDayId = 0;
  let endDayId = startDayId;
  const condensatedOpenHours = [];
  Object.keys(dropOffBranch.work_hours).forEach(dayId => {
    const currentDayWorkHours = dropOffBranch.work_hours[dayId].flat();
    const nextDayWorkHours = dropOffBranch.work_hours[Number(dayId) + 1] ? dropOffBranch.work_hours[Number(dayId) + 1].flat() : null;
    if (currentDayWorkHours && nextDayWorkHours && currentDayWorkHours.length === nextDayWorkHours.length && currentDayWorkHours.every((value, index) => value === nextDayWorkHours[index]) || !currentDayWorkHours && !nextDayWorkHours && endDayId < helpers_utils__WEBPACK_IMPORTED_MODULE_0__/* .weekDays */ .Mq.length - 1) {
      endDayId += 1;
    } else {
      const daysName = startDayId === endDayId ? helpers_utils__WEBPACK_IMPORTED_MODULE_0__/* .weekDays */ .Mq[startDayId].slice(0, 2) : "".concat(helpers_utils__WEBPACK_IMPORTED_MODULE_0__/* .weekDays */ .Mq[startDayId].slice(0, 2), "\u2013").concat(helpers_utils__WEBPACK_IMPORTED_MODULE_0__/* .weekDays */ .Mq[endDayId].slice(0, 2));
      condensatedOpenHours.push({
        day: daysName,
        openHours: dropOffBranch.work_hours[startDayId] && dropOffBranch.work_hours[startDayId].map(hour => hour.join('\u2013')).join(', ') || gettext('closed')
      });
      endDayId += 1;
      startDayId = endDayId;
    }
  });
  return condensatedOpenHours;
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  getShippingProviderLogo,
  getShippingProviderName,
  getShippingTypePrice,
  getShippingTypesPriceStr,
  condensateOpenHours
});

/***/ }),

/***/ 25193:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   pH: () => (/* binding */ allCurrenciesSymbol)
/* harmony export */ });
/* unused harmony exports ONBOARDING_SAMPLE_ORDER_CODE, flags, historyItemTypes, notificationTypes, allCountries, allLanguages, allLanguagesLocalised, countryCodeToCountryName, allCurrenciesName, supportedLanguages */
const ONBOARDING_SAMPLE_ORDER_CODE = 'TUTORIAL-0001';
const flags = {
  FLAG_CREATED_BY_SHOPTET: 'created_by_shoptet',
  FLAG_SHOPTET_API_IMPORT_ORDERS: 'shoptet_api_import_orders',
  FLAG_IS_DISABLED: 'is_disabled',
  FLAG_IS_RETINO_SALES: 'is_retino_sales',
  FLAG_IS_RETINO_ADMIN: 'is_retino_admin',
  FLAG_ENABLE_KEYBOARD_SHORTCUTS: 'enable_keyboard_shortcuts',
  FLAG_DISPLAY_TRANSPORT_SETTINGS: 'display_doprava_settings',
  FLAG_DISPLAY_API_SETTINGS: 'display_api_settings',
  FLAG_DISPLAY_BADGE_SETTINGS: 'display_odznak_settings',
  FLAG_DISPLAY_BILLING_SETTINGS: 'display_billing_settings',
  FLAG_SAMPLE_TICKET: 'sample_ticket'
};
const historyItemTypes = {
  MESSAGE: 'MESSAGE',
  SYSTEM: 'SYSTEM',
  DOCUMENT: 'DOCUMENT',
  TRANSPORT: 'TRANSPORT',
  SHIPPING_REQUEST: 'SHIPPING_REQUEST',
  INTERNAL_NOTE: 'INTERNAL_NOTE',
  RATING_COMMENT: 'RATING_COMMENT',
  REFUND_REQUEST: 'REFUND_REQUEST',
  ACTIVITY: 'ACTIVITY'
};
const notificationTypes = {
  TICKET_MESSAGE_ADDED_BY_CUSTOMER: 'TICKET_MESSAGE_ADDED_BY_CUSTOMER',
  TICKET_MESSAGE_UNDELIVERED: 'TICKET_MESSAGE_UNDELIVERED',
  TICKET_CREATED_BY_CUSTOMER: 'TICKET_CREATED_BY_CUSTOMER',
  TICKET_UPCOMING_DATE: 'TICKET_UPCOMING_DATE',
  TICKET_ASSIGNED: 'TICKET_ASSIGNED',
  TICKET_RATED: 'TICKET_RATED'
};
const allCountries = {
  AU: gettext('Australia'),
  AT: gettext('Austria'),
  BY: gettext('Belarus'),
  BE: gettext('Belgium'),
  BA: gettext('Bosnia and Herzegovina'),
  BG: gettext('Bulgaria'),
  CA: gettext('Canada'),
  CN: gettext('China'),
  HR: gettext('Croatia'),
  CY: gettext('Cyprus'),
  CZ: gettext('Czechia'),
  DK: gettext('Denmark'),
  EE: gettext('Estonia'),
  FI: gettext('Finland'),
  FR: gettext('France'),
  DE: gettext('Germany'),
  GR: gettext('Greece'),
  GL: gettext('Greenland'),
  HU: gettext('Hungary'),
  IS: gettext('Iceland'),
  IN: gettext('India'),
  IE: gettext('Ireland'),
  IT: gettext('Italy'),
  LV: gettext('Latvia'),
  LI: gettext('Liechtenstein'),
  LT: gettext('Lithuania'),
  LU: gettext('Luxembourg'),
  MK: gettext('Macedonia'),
  MT: gettext('Malta'),
  MD: gettext('Moldova'),
  MC: gettext('Monaco'),
  ME: gettext('Montenegro'),
  NL: gettext('Netherlands'),
  NO: gettext('Norway'),
  PL: gettext('Poland'),
  PT: gettext('Portugal'),
  QA: gettext('Qatar'),
  RO: gettext('Romania'),
  RU: gettext('Russian Federation'),
  SA: gettext('Saudi Arabia'),
  RS: gettext('Serbia'),
  SK: gettext('Slovakia'),
  SI: gettext('Slovenia'),
  ZA: gettext('South Africa'),
  ES: gettext('Spain'),
  SE: gettext('Sweden'),
  CH: gettext('Switzerland'),
  TW: gettext('Taiwan (Province of China)'),
  TR: gettext('Turkey'),
  UA: gettext('Ukraine'),
  AE: gettext('United Arab Emirates'),
  GB: gettext('United Kingdom of Great Britain and Northern Ireland'),
  US: gettext('United States of America'),
  VN: gettext('Viet Nam')
};
const allLanguages = {
  en: gettext('English'),
  de: gettext('German'),
  'de-at': gettext('German (Austria)'),
  'de-ch': gettext('German (Switzerland)'),
  cs: gettext('Czech'),
  sk: gettext('Slovak'),
  pl: gettext('Polish'),
  hu: gettext('Hungarian'),
  ro: gettext('Romanian'),
  es: gettext('Spanish'),
  it: gettext('Italian'),
  'it-ch': gettext('Italian (Switzerland)'),
  fr: gettext('French'),
  'fr-ch': gettext('French (Switzerland)'),
  'fr-be': gettext('French (Belgium)'),
  hr: gettext('Croatian'),
  bg: gettext('Bulgarian'),
  sl: gettext('Slovenian'),
  el: gettext('Greek'),
  nl: gettext('Dutch'),
  'nl-be': gettext('Dutch (Belgium)'),
  nb: gettext('Norwegian'),
  lv: gettext('Latvian'),
  lt: gettext('Lithuanian'),
  et: gettext('Estonian'),
  da: gettext('Danish'),
  sv: gettext('Swedish'),
  fi: gettext('Finnish'),
  pt: gettext('Portuguese'),
  uk: gettext('Ukrainian')
};
const allLanguagesLocalised = {
  en: 'English',
  de: 'Deutsch',
  'de-at': 'Deutsch (Österreich)',
  'de-ch': 'Deutsch (Schweiz)',
  cs: 'Česky',
  sk: 'Slovenčina',
  pl: 'Polski',
  hu: 'Magyar',
  ro: 'Română',
  es: 'Espanol',
  it: 'Italiano',
  'it-ch': 'Italiano (Svizzera)',
  fr: 'Français',
  'fr-ch': 'Français (Suisse)',
  'fr-be': 'Français (Belgique)',
  nb: 'Norsk',
  hr: 'Hrvatski',
  bg: 'български',
  sl: 'Slovenščina',
  et: 'Eesti',
  el: 'Ελληνικά',
  lt: 'Lietuvių',
  lv: 'Latviešu',
  nl: 'Nederlandse',
  'nl-be': 'Nederlands (België)',
  da: 'Dansk',
  fi: 'Suomi',
  sv: 'Svenska',
  pt: 'Português',
  uk: 'Українська'
};
const countryCodeToCountryName = countryCode => {
  const displayNames = new Intl.DisplayNames([window.appState.lang], {
    type: 'region'
  });
  try {
    return displayNames.of(countryCode);
  } catch (e) {
    // In case when country code is not valid, return the country code itself
    return countryCode;
  }
};
const allCurrenciesName = {
  AUD: gettext('Australian dollar'),
  BGN: gettext('Bulgarian lev'),
  CAD: gettext('Canadian dollar'),
  CZK: gettext('Czech koruna'),
  DKK: gettext('Danish krone'),
  EUR: gettext('Euro'),
  GBP: gettext('British pound'),
  HRK: gettext('Croatian kuna'),
  HUF: gettext('Hungarian forint'),
  CHF: gettext('Swiss franc'),
  ILS: gettext('Israeli new shekel'),
  JPY: gettext('Japanese yen'),
  MXN: gettext('Mexican peso'),
  NOK: gettext('Norwegian krone'),
  PLN: gettext('Polish złoty'),
  RON: gettext('Romanian leu'),
  SEK: gettext('Swedish krona'),
  SGD: gettext('Singapore dollar'),
  THB: gettext('Thai baht'),
  UAH: gettext('Ukrainian hryvnia'),
  USD: gettext('United States dollar')
};
const allCurrenciesSymbol = {
  CZK: 'Kč',
  EUR: '€',
  PLN: 'zł',
  GBP: '£',
  RON: 'lei',
  HUF: 'Ft',
  UAH: '₴',
  CHF: 'Fr',
  USD: '$',
  HRK: 'kn',
  BGN: 'лв',
  AUD: '$',
  CAD: '$',
  DKK: 'kr',
  ILS: '₪',
  JPY: '¥',
  MXN: '$',
  SEK: 'kr',
  SGD: '$',
  THB: '฿',
  NOK: 'kr'
};
const supportedLanguages = (/* unused pure expression or super */ null && (['cs', 'hu', 'ro', 'en']));
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  flags,
  historyItemTypes,
  notificationTypes
});

/***/ }),

/***/ 5367:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95626);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35443);
/* harmony import */ var _CardContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98736);
/* harmony import */ var _CardFooter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66058);
/* harmony import */ var _CardHeader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5376);






function Card(_ref) {
  let {
    id,
    basic,
    children,
    loading = false,
    flat = false
  } = _ref;
  const classArray = ['relative', 'bg-white', 'rounded-lg'];
  if (flat) {
    classArray.push('border', 'border-gray-200');
  } else {
    classArray.push('shadow');
  }
  if (basic) {
    classArray.push('card-basic'); // custom class
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classArray.join(' '),
    id: id
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Transition */ .e, {
    className: "absolute inset-0 z-20",
    show: loading,
    enter: "transition ease-in duration-50",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition ease-out duration-50",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute inset-0 z-20 flex items-center justify-center rounded-lg bg-white opacity-70"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Loader */ .aH, {
    size: "huge"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "contents"
  }, children));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Object.assign(Card, {
  Content: _CardContent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A,
  Header: _CardHeader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A,
  Footer: _CardFooter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A
}));

/***/ }),

/***/ 35443:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  $n: () => (/* reexport */ button_Button/* default */.A),
  Zp: () => (/* reexport */ Card/* default */.A),
  cG: () => (/* reexport */ Divider/* default */.A),
  JY: () => (/* reexport */ Feed/* default */.A),
  lV: () => (/* reexport */ Form/* default */.A),
  In: () => (/* reexport */ icon_Icon/* default */.Ay$),
  JU: () => (/* reexport */ Label/* default */.A),
  aH: () => (/* reexport */ Loader/* default */.A),
  QB: () => (/* reexport */ Message/* default */.A),
  aF: () => (/* reexport */ modal_Modal/* default */.A),
  pF: () => (/* reexport */ named_propery_NamedProperty),
  hJ: () => (/* reexport */ Overlay/* default */.A),
  zD: () => (/* reexport */ Popup/* default */.A),
  ZL: () => (/* reexport */ Portal/* default */.A),
  z2: () => (/* reexport */ ProgressBar/* default */.A),
  Y4: () => (/* reexport */ Segment/* default */.A),
  N9: () => (/* reexport */ ToastContainer/* default */.A),
  oR: () => (/* reexport */ toast/* default */.A)
});

// UNUSED EXPORTS: ActionPanel, Breadcrumbs, Checkbox, CodeInput, Collapse, CollapsibleText, Confirm, Dimmer, Dropdown, FeedEvent, Input, Multiselect, Pagination, Radio, RadioPanel, Select, SlideOver, Statistic, Step, StepGroup, Table, Tabs, Textarea

// EXTERNAL MODULE: ./react/ui/action-panel/ActionPanel.tsx
var ActionPanel = __webpack_require__(50188);
// EXTERNAL MODULE: ./react/ui/breadcrumbs/Breadcrumbs.tsx
var Breadcrumbs = __webpack_require__(45181);
// EXTERNAL MODULE: ./react/ui/button/Button.tsx
var button_Button = __webpack_require__(43787);
// EXTERNAL MODULE: ./react/ui/card/Card.tsx
var Card = __webpack_require__(5367);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
;// ./react/ui/form/code-input/CodeInput.tsx

function CodeInput(_ref) {
  let {
    length = 6,
    value,
    onChange,
    error,
    autoFocus,
    onComplete,
    alphanumeric = false
  } = _ref;
  const inputRefs = useRef([]);
  const completedRef = useRef(false);
  useEffect(() => {
    if (autoFocus && inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, [autoFocus]);
  useEffect(() => {
    if (value.length === length && onComplete && !completedRef.current) {
      completedRef.current = true;
      onComplete(value);
    } else if (value.length < length) {
      completedRef.current = false;
    }
  }, [value, length, onComplete]);
  const handleChange = (index, char) => {
    const pattern = alphanumeric ? /^[a-zA-Z0-9]*$/ : /^\d*$/;
    if (!pattern.test(char)) return;
    const newValue = value.split('');
    newValue[index] = char.slice(-1).toUpperCase();
    const joined = newValue.join('').slice(0, length);
    onChange(joined);
    if (char && index < length - 1) {
      var _inputRefs$current;
      (_inputRefs$current = inputRefs.current[index + 1]) === null || _inputRefs$current === void 0 || _inputRefs$current.focus();
    }
  };
  const handleKeyDown = (index, e) => {
    // Handle backspace: clear current digit or move to previous
    if (e.key === 'Backspace') {
      e.preventDefault(); // Prevent default to control deletion ourselves
      const newValue = value.split('');
      if (newValue[index]) {
        newValue[index] = '';
        onChange(newValue.join(''));
      } else if (index > 0) {
        var _inputRefs$current2;
        newValue[index - 1] = '';
        onChange(newValue.join(''));
        (_inputRefs$current2 = inputRefs.current[index - 1]) === null || _inputRefs$current2 === void 0 || _inputRefs$current2.focus();
      }
      return;
    }

    // Handle arrow navigation between inputs
    if (e.key === 'ArrowLeft' && index > 0) {
      var _inputRefs$current3;
      e.preventDefault(); // Prevent cursor movement inside input
      (_inputRefs$current3 = inputRefs.current[index - 1]) === null || _inputRefs$current3 === void 0 || _inputRefs$current3.focus();
    } else if (e.key === 'ArrowRight' && index < length - 1) {
      var _inputRefs$current4;
      e.preventDefault(); // Prevent cursor movement inside input
      (_inputRefs$current4 = inputRefs.current[index + 1]) === null || _inputRefs$current4 === void 0 || _inputRefs$current4.focus();
    }
  };
  const handlePaste = e => {
    e.preventDefault(); // Prevent default single-char paste, handle full code paste
    const pattern = alphanumeric ? /[^a-zA-Z0-9]/g : /\D/g;
    const pastedData = e.clipboardData.getData('text').replace(pattern, '').slice(0, length).toUpperCase();
    if (pastedData) {
      var _inputRefs$current$fo;
      onChange(pastedData);
      const focusIndex = Math.min(pastedData.length, length - 1);
      (_inputRefs$current$fo = inputRefs.current[focusIndex]) === null || _inputRefs$current$fo === void 0 || _inputRefs$current$fo.focus();
    }
  };
  const handleFocus = e => {
    e.target.select();
  };
  const digits = Array.from({
    length
  }, (_, i) => value[i] || '');
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap justify-center gap-2"
  }, digits.map((digit, index) => /*#__PURE__*/React.createElement("input", {
    key: index,
    ref: el => {
      inputRefs.current[index] = el;
    },
    type: "text",
    inputMode: alphanumeric ? 'text' : 'numeric',
    autoComplete: "one-time-code",
    "aria-label": interpolate(gettext('Digit %s'), [index + 1]),
    maxLength: 1,
    value: digit,
    onChange: e => handleChange(index, e.target.value),
    onKeyDown: e => handleKeyDown(index, e),
    onPaste: handlePaste,
    onFocus: handleFocus,
    className: "h-12 w-10 rounded-lg text-center font-mono text-lg font-semibold shadow-sm ring-1 transition-colors focus:-outline-offset-1 focus:outline-2 ".concat(error ? 'text-red-900 ring-red-300 focus:outline-red-500' : 'text-gray-900 ring-black/10 focus:outline-indigo-500')
  }))), error && /*#__PURE__*/React.createElement("p", {
    className: "mt-2 text-center text-sm text-red-600"
  }, error));
}
/* harmony default export */ const code_input_CodeInput = ((/* unused pure expression or super */ null && (CodeInput)));
;// ./react/ui/confirm/Confirm.tsx
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


function Confirm(_ref) {
  let {
    header = gettext('Confirm'),
    content = gettext('Are you sure?'),
    children,
    confirmButton = {},
    cancelButton = {
      children: gettext('Cancel')
    },
    negative = false,
    confirmDelete = false,
    onConfirm,
    onCancel,
    size
  } = _ref;
  const [isOpen, setIsOpen] = useState(false);
  const handleConfirm = () => {
    setIsOpen(false);
    onConfirm();
  };
  const handleCancel = () => {
    setIsOpen(false);
    if (onCancel) onCancel();
  };
  confirmButton.onClick = handleConfirm;
  cancelButton.onClick = handleCancel;
  if (negative) {
    confirmButton = _objectSpread({
      negative: true
    }, confirmButton);
  } else {
    confirmButton = _objectSpread({
      primary: true,
      children: gettext('Confirm')
    }, confirmButton);
  }
  if (confirmDelete) {
    confirmButton = _objectSpread({
      children: gettext('Delete')
    }, confirmButton);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(children, {
    onClick: e => {
      e.stopPropagation();
      setIsOpen(true);
    }
  }), /*#__PURE__*/React.createElement(Modal, {
    open: isOpen,
    onClose: handleCancel,
    size: size
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement("div", {
    className: "sm:flex sm:items-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "exclamation",
    className: "h-6 w-6 text-red-600"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-lg font-medium leading-6 text-gray-900",
    id: "modal-headline"
  }, header), /*#__PURE__*/React.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-sm text-gray-500"
  }, content))))), /*#__PURE__*/React.createElement(Modal.Footer, {
    gray: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-end gap-3"
  }, /*#__PURE__*/React.createElement(Button, _extends({
    classNames: classes => [...classes, 'sm:mt-0', 'sm:w-auto', 'sm:text-sm']
  }, cancelButton)), /*#__PURE__*/React.createElement(Button, _extends({
    classNames: classes => [...classes, 'sm:w-auto', 'sm:text-sm']
  }, confirmButton))))));
}
/* harmony default export */ const confirm_Confirm = ((/* unused pure expression or super */ null && (Confirm)));
// EXTERNAL MODULE: ./react/ui/dimmer/Dimmer.tsx
var Dimmer = __webpack_require__(81647);
// EXTERNAL MODULE: ./react/ui/divider/Divider.tsx
var Divider = __webpack_require__(81245);
// EXTERNAL MODULE: ./react/ui/dropdown/Dropdown.tsx
var Dropdown = __webpack_require__(94557);
// EXTERNAL MODULE: ./react/ui/feed/Feed.tsx
var Feed = __webpack_require__(45751);
// EXTERNAL MODULE: ./react/ui/feed/FeedEvent.tsx
var FeedEvent = __webpack_require__(31871);
// EXTERNAL MODULE: ./react/ui/form/Form.tsx
var Form = __webpack_require__(14823);
// EXTERNAL MODULE: ./react/ui/form/checkbox/Checkbox.tsx
var Checkbox = __webpack_require__(95520);
// EXTERNAL MODULE: ./react/ui/icon/Icon.tsx + 454 modules
var icon_Icon = __webpack_require__(53623);
// EXTERNAL MODULE: ./react/ui/form/input/Input.tsx
var Input = __webpack_require__(31496);
// EXTERNAL MODULE: ./react/ui/label/Label.tsx
var Label = __webpack_require__(69817);
// EXTERNAL MODULE: ./react/ui/loader/Loader.tsx
var Loader = __webpack_require__(473);
// EXTERNAL MODULE: ./react/ui/message/Message.tsx
var Message = __webpack_require__(69349);
// EXTERNAL MODULE: ./react/ui/modal/Modal.tsx
var modal_Modal = __webpack_require__(95857);
// EXTERNAL MODULE: ./react/ui/form/multiselect/Multiselect.tsx + 1 modules
var Multiselect = __webpack_require__(4922);
;// ./react/ui/named-propery/NamedProperty.tsx

function NamedProperty(_ref) {
  let {
    name,
    value
  } = _ref;
  return /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "text-sm font-medium text-gray-500"
  }, name), /*#__PURE__*/react.createElement("div", {
    className: "mt-1 text-sm text-gray-900"
  }, value));
}
/* harmony default export */ const named_propery_NamedProperty = (NamedProperty);
// EXTERNAL MODULE: ./react/ui/overlay/Overlay.tsx
var Overlay = __webpack_require__(65321);
// EXTERNAL MODULE: ./react/ui/pagination/Pagination.tsx
var Pagination = __webpack_require__(29635);
// EXTERNAL MODULE: ./react/ui/popup/Popup.tsx
var Popup = __webpack_require__(59005);
// EXTERNAL MODULE: ./react/ui/portal/Portal.tsx
var Portal = __webpack_require__(95971);
// EXTERNAL MODULE: ./react/ui/progressbar/ProgressBar.tsx
var ProgressBar = __webpack_require__(7777);
// EXTERNAL MODULE: ./react/ui/form/radio/Radio.tsx
var Radio = __webpack_require__(51304);
// EXTERNAL MODULE: ./react/ui/segment/Segment.tsx
var Segment = __webpack_require__(16369);
// EXTERNAL MODULE: ./react/ui/form/select/Select.tsx
var Select = __webpack_require__(44874);
// EXTERNAL MODULE: ./react/ui/slide-over/SlideOver.tsx
var SlideOver = __webpack_require__(33708);
// EXTERNAL MODULE: ./react/ui/statistic/Statistic.tsx
var Statistic = __webpack_require__(18973);
// EXTERNAL MODULE: ./react/ui/step/Step.tsx
var Step = __webpack_require__(747);
// EXTERNAL MODULE: ./react/ui/step/StepGroup.tsx
var StepGroup = __webpack_require__(17526);
// EXTERNAL MODULE: ./react/ui/table/Table.tsx
var Table = __webpack_require__(19873);
// EXTERNAL MODULE: ./react/ui/tabs/Tabs.tsx + 1 modules
var Tabs = __webpack_require__(46305);
// EXTERNAL MODULE: ./react/ui/form/textarea/Textarea.tsx
var Textarea = __webpack_require__(97670);
// EXTERNAL MODULE: ./react/ui/toast/index.ts
var toast = __webpack_require__(82468);
// EXTERNAL MODULE: ./react/ui/toast/ToastContainer.tsx + 1 modules
var ToastContainer = __webpack_require__(34161);
// EXTERNAL MODULE: ./react/ui/collapse/Collapse.tsx
var Collapse = __webpack_require__(84373);
// EXTERNAL MODULE: ./react/ui/collapsible-text/CollapsibleText.tsx
var CollapsibleText = __webpack_require__(7522);
// EXTERNAL MODULE: ./react/ui/form/radioPanel/RadioPanel.tsx
var RadioPanel = __webpack_require__(43320);
;// ./react/ui/index.ts











































/***/ }),

/***/ 69349:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35443);


const getBackgroundColor = color => {
  switch (color) {
    case 'red':
      return 'bg-red-50';
    case 'yellow':
      return 'bg-yellow-50';
    case 'green':
      return 'bg-green-50';
    case 'blue':
      return 'bg-blue-50';
    default:
      return 'bg-blue-50';
  }
};
const getHeadingTextColor = color => {
  switch (color) {
    case 'red':
      return 'text-red-800';
    case 'yellow':
      return 'text-yellow-800';
    case 'green':
      return 'text-green-800';
    case 'blue':
      return 'text-blue-800';
    default:
      return 'text-blue-800';
  }
};
const getTextColor = color => {
  switch (color) {
    case 'red':
      return 'text-red-700';
    case 'yellow':
      return 'text-yellow-700';
    case 'green':
      return 'text-green-700';
    case 'blue':
      return 'text-blue-700';
    default:
      return 'text-blue-700';
  }
};
const getBorderColor = color => {
  switch (color) {
    case 'red':
      return 'border-red-400';
    case 'yellow':
      return 'border-yellow-400';
    case 'green':
      return 'border-green-400';
    case 'blue':
      return 'border-blue-400';
    default:
      return 'border-blue-400';
  }
};
function Message(_ref) {
  let {
    error = false,
    warning = false,
    success = false,
    info = false,
    border = false,
    heading,
    children,
    displayIcon = true
  } = _ref;
  let color;
  let icon;
  const iconContainerClasses = ['flex-shrink-0'];
  const containerClasses = ['rounded-md', 'p-4'];
  const contentClasses = ['w-full'];
  const headingClasses = ['text-sm', 'font-medium', 'mb-2'];
  const childrenClasses = ['text-sm'];
  if (error) {
    color = 'red';
    icon = 'x-circle';
    iconContainerClasses.push('-mt-1');
  } else if (warning) {
    color = 'yellow';
    icon = 'exclamation';
    iconContainerClasses.push('-mt-0.5');
  } else if (success) {
    color = 'green';
    icon = 'check-circle';
    iconContainerClasses.push('-mt-1');
  } else {
    color = 'blue';
    icon = 'information-circle';
    iconContainerClasses.push('-mt-1');
  }
  containerClasses.push(getBackgroundColor(color));
  if (border) {
    containerClasses.push("border");
    containerClasses.push(getBorderColor(color));
  }
  headingClasses.push(getHeadingTextColor(color));
  childrenClasses.push(getTextColor(color));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: containerClasses.join(' ')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex gap-1"
  }, displayIcon && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: iconContainerClasses.join(' ')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .In, {
    name: icon,
    color: color,
    fitted: true
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: contentClasses.join(' ')
  }, heading && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("h3", {
    className: headingClasses.join(' ')
  }, heading), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: childrenClasses.join(' ')
  }, children))));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Message);

/***/ }),

/***/ 95857:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95626);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35443);
/* harmony import */ var ui_loader_Loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(473);
/* harmony import */ var _ModalContent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59910);
/* harmony import */ var _ModalFooter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81972);
/* harmony import */ var _ModalHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91446);







function getSizeClass(size) {
  switch (size) {
    case 'sm':
      return 'max-w-sm';
    case 'md':
      return 'max-w-md';
    case 'lg':
      return 'max-w-lg';
    case 'xl':
      return 'max-w-xl';
    case '2xl':
      return 'max-w-2xl';
    case '3xl':
      return 'max-w-3xl';
    case '4xl':
      return 'max-w-4xl';
    case '5xl':
      return 'max-w-5xl';
    case '6xl':
      return 'max-w-6xl';
    case '7xl':
      return 'max-w-7xl';
    default:
      return 'max-w-lg';
  }
}
const getMaxSizeClassName = size => {
  switch (size) {
    case 'sm':
      return 'max-w-sm';
    case 'md':
      return 'max-w-md';
    case 'lg':
      return 'max-w-lg';
    case 'xl':
      return 'max-w-xl';
    case '2xl':
      return 'max-w-2xl';
    case '3xl':
      return 'max-w-3xl';
    case '4xl':
      return 'max-w-4xl';
    case '5xl':
      return 'max-w-5xl';
    case '6xl':
      return 'max-w-6xl';
    case '7xl':
      return 'max-w-7xl';
    default:
      return 'max-w-lg';
  }
};
function Modal(_ref) {
  let {
    id,
    loading = false,
    size = 'lg',
    dismissible = false,
    open,
    onClose,
    children
  } = _ref;
  const keyListener = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const handleClose = () => {
    if (onClose) onClose();
  };
  const handleOverlayClick = () => {
    handleClose();
  };
  const listenToEscape = e => {
    if (e.keyCode === 27) {
      handleClose(); // close on escape
    }
  };
  const addListener = () => {
    if (!keyListener.current) {
      window.addEventListener('keydown', listenToEscape, false);
      keyListener.current = listenToEscape;
    }
  };
  const removeListener = () => {
    if (keyListener.current) {
      window.removeEventListener('keydown', keyListener.current, false);
      keyListener.current = null;
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (open) {
      addListener();
    } else {
      removeListener();
    }
    return () => {
      removeListener();
    };
  }, [open]);
  const sizeClass = getSizeClass(size);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Overlay */ .hJ, {
    open: open,
    onOverlayClick: handleOverlayClick
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Transition */ .e, {
    id: id,
    show: open,
    className: "inline-block transform overflow-visible rounded-lg bg-white text-left shadow-xl transition-all my-8 align-middle ".concat(sizeClass, " w-full"),
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": "modal-headline",
    enter: "ease-out duration-300",
    enterFrom: "opacity-0 translate-y-4 translate-y-0 scale-95",
    enterTo: "opacity-100 translate-y-0 scale-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100 translate-y-0 scale-100",
    leaveTo: "opacity-0 translate-y-4 translate-y-0 scale-95"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Transition */ .e, {
    className: "absolute inset-0 z-50",
    show: loading,
    enter: "transition ease-in duration-50",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition ease-out duration-50",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute inset-0 z-20 flex items-center justify-center bg-white opacity-70 rounded-lg"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_loader_Loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A, {
    size: "huge"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    onClick: e => e.stopPropagation(),
    className: "contents"
  }, children), dismissible && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute top-0 right-0 hidden pt-4 pr-4 block"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    type: "button",
    className: "rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
    onClick: () => handleClose()
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "sr-only"
  }, gettext('Close')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .In, {
    name: "x",
    className: "h-6 w-6",
    "aria-hidden": "true"
  })))));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Object.assign(Modal, {
  Header: _ModalHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A,
  Content: _ModalContent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A,
  Footer: _ModalFooter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A
}));

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	(() => {
/******/ 		var getProto = Object.getPrototypeOf ? (obj) => (Object.getPrototypeOf(obj)) : (obj) => (obj.__proto__);
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; typeof current == 'object' && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach((key) => (def[key] = () => (value[key])));
/******/ 			}
/******/ 			def['default'] = () => (value);
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/harmony module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.hmd = (module) => {
/******/ 			module = Object.create(module);
/******/ 			if (!module.children) module.children = [];
/******/ 			Object.defineProperty(module, 'exports', {
/******/ 				enumerable: true,
/******/ 				set: () => {
/******/ 					throw new Error('ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: ' + module.id);
/******/ 				}
/******/ 			});
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			345: 0,
/******/ 			541: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkretino"] = self["webpackChunkretino"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, [311,15,670,400,136,767,87,308,276,591,541,256,406,977,704], () => (__webpack_require__(27461)))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [311,15,670,400,136,767,87,308,276,591,541,256,406,977,704], () => (__webpack_require__(63680)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;